// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
#login .pointer-events-none {
    pointer-events: none;
}
#login .visible {
    visibility: visible;
}
#login .invisible {
    visibility: hidden;
}
#login .fixed {
    position: fixed;
}
#login .absolute {
    position: absolute;
}
#login .relative {
    position: relative;
}
#login .inset-0 {
    inset: 0px;
}
#login .inset-1\\/2 {
    inset: 50%;
}
#login .inset-x-1\\/2 {
    left: 50%;
    right: 50%;
}
#login .inset-y-0 {
    top: 0px;
    bottom: 0px;
}
#login .bottom-0 {
    bottom: 0px;
}
#login .bottom-1\\/3 {
    bottom: 33.333333%;
}
#login .left-0 {
    left: 0px;
}
#login .left-1\\/2 {
    left: 50%;
}
#login .left-2\\.5 {
    left: 0.625rem;
}
#login .left-3 {
    left: 0.75rem;
}
#login .left-4 {
    left: 1rem;
}
#login .left-\\[14px\\] {
    left: 14px;
}
#login .left-\\[18px\\] {
    left: 18px;
}
#login .left-\\[5px\\] {
    left: 5px;
}
#login .right-0 {
    right: 0px;
}
#login .right-1 {
    right: 0.25rem;
}
#login .right-2\\.5 {
    right: 0.625rem;
}
#login .right-4 {
    right: 1rem;
}
#login .start-1 {
    inset-inline-start: 0.25rem;
}
#login .top-0 {
    top: 0px;
}
#login .top-1\\/2 {
    top: 50%;
}
#login .top-2 {
    top: 0.5rem;
}
#login .top-2\\.5 {
    top: 0.625rem;
}
#login .top-3 {
    top: 0.75rem;
}
#login .top-4 {
    top: 1rem;
}
#login .top-full {
    top: 100%;
}
#login .isolate {
    isolation: isolate;
}
#login .z-0 {
    z-index: 0;
}
#login .z-10 {
    z-index: 10;
}
#login .z-20 {
    z-index: 20;
}
#login .z-30 {
    z-index: 30;
}
#login .z-40 {
    z-index: 40;
}
#login .z-50 {
    z-index: 50;
}
#login .z-\\[1\\] {
    z-index: 1;
}
#login .order-last {
    order: 9999;
}
#login .col-start-2 {
    grid-column-start: 2;
}
#login .col-start-3 {
    grid-column-start: 3;
}
#login .row-start-1 {
    grid-row-start: 1;
}
#login .row-start-2 {
    grid-row-start: 2;
}
#login .-m-1 {
    margin: -0.25rem;
}
#login .m-auto {
    margin: auto;
}
#login .-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
}
#login .mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
}
#login .mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
#login .my-auto {
    margin-top: auto;
    margin-bottom: auto;
}
#login .-ml-2 {
    margin-left: -0.5rem;
}
#login .-ml-4 {
    margin-left: -1rem;
}
#login .-ml-px {
    margin-left: -1px;
}
#login .-mt-px {
    margin-top: -1px;
}
#login .mb-1 {
    margin-bottom: 0.25rem;
}
#login .mb-1\\.5 {
    margin-bottom: 0.375rem;
}
#login .ml-3 {
    margin-left: 0.75rem;
}
#login .ml-auto {
    margin-left: auto;
}
#login .mr-1 {
    margin-right: 0.25rem;
}
#login .mr-px {
    margin-right: 1px;
}
#login .mt-2 {
    margin-top: 0.5rem;
}
#login .mt-8 {
    margin-top: 2rem;
}
#login .box-border {
    box-sizing: border-box;
}
#login .block {
    display: block;
}
#login .flex {
    display: flex;
}
#login .inline-flex {
    display: inline-flex;
}
#login .table {
    display: table;
}
#login .table-cell {
    display: table-cell;
}
#login .table-row {
    display: table-row;
}
#login .grid {
    display: grid;
}
#login .inline-grid {
    display: inline-grid;
}
#login .contents {
    display: contents;
}
#login .hidden {
    display: none;
}
#login .aspect-square {
    aspect-ratio: 1 / 1;
}
#login .size-12 {
    width: 3rem;
    height: 3rem;
}
#login .h-1 {
    height: 0.25rem;
}
#login .h-1\\.5 {
    height: 0.375rem;
}
#login .h-10 {
    height: 2.5rem;
}
#login .h-11 {
    height: 2.75rem;
}
#login .h-13 {
    height: 3.25rem;
}
#login .h-14 {
    height: 3.5rem;
}
#login .h-15 {
    height: 3.75rem;
}
#login .h-16 {
    height: 4rem;
}
#login .h-2 {
    height: 0.5rem;
}
#login .h-28 {
    height: 7rem;
}
#login .h-3\\.5 {
    height: 0.875rem;
}
#login .h-4 {
    height: 1rem;
}
#login .h-4\\.5 {
    height: 1.125rem;
}
#login .h-5 {
    height: 1.25rem;
}
#login .h-6 {
    height: 1.5rem;
}
#login .h-6\\.5 {
    height: 1.625rem;
}
#login .h-7 {
    height: 1.75rem;
}
#login .h-7\\.5 {
    height: 1.875rem;
}
#login .h-72 {
    height: 18rem;
}
#login .h-8 {
    height: 2rem;
}
#login .h-8\\.5 {
    height: 2.125rem;
}
#login .h-9 {
    height: 2.25rem;
}
#login .h-96 {
    height: 24rem;
}
#login .h-\\[1\\.125rem\\] {
    height: 1.125rem;
}
#login .h-\\[1\\.625rem\\] {
    height: 1.625rem;
}
#login .h-\\[1\\.875rem\\] {
    height: 1.875rem;
}
#login .h-\\[1px\\] {
    height: 1px;
}
#login .h-\\[2\\.125rem\\] {
    height: 2.125rem;
}
#login .h-\\[2\\.375rem\\] {
    height: 2.375rem;
}
#login .h-\\[2\\.625rem\\] {
    height: 2.625rem;
}
#login .h-\\[var\\(--cmdk-list-height\\)\\] {
    height: var(--cmdk-list-height);
}
#login .h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height);
}
#login .h-auto {
    height: auto;
}
#login .h-fit {
    height: -moz-fit-content;
    height: fit-content;
}
#login .h-full {
    height: 100%;
}
#login .h-px {
    height: 1px;
}
#login .h-screen {
    height: 100vh;
}
#login .max-h-\\[calc\\(100vh-3rem\\)\\] {
    max-height: calc(100vh - 3rem);
}
#login .max-h-\\[var\\(--radix-popover-content-available-height\\)\\] {
    max-height: var(--radix-popover-content-available-height);
}
#login .max-h-\\[var\\(--radix-select-content-available-height\\)\\] {
    max-height: var(--radix-select-content-available-height);
}
#login .max-h-screen {
    max-height: 100vh;
}
#login .min-h-0 {
    min-height: 0px;
}
#login .min-h-13 {
    min-height: 3.25rem;
}
#login .min-h-16 {
    min-height: 4rem;
}
#login .min-h-8 {
    min-height: 2rem;
}
#login .min-h-\\[2\\.25rem\\] {
    min-height: 2.25rem;
}
#login .min-h-\\[2\\.75rem\\] {
    min-height: 2.75rem;
}
#login .min-h-\\[3\\.75rem\\] {
    min-height: 3.75rem;
}
#login .min-h-\\[54px\\] {
    min-height: 54px;
}
#login .min-h-full {
    min-height: 100%;
}
#login .w-0 {
    width: 0px;
}
#login .w-0\\.25 {
    width: 0.0625rem;
}
#login .w-1\\/2 {
    width: 50%;
}
#login .w-1\\/3 {
    width: 33.333333%;
}
#login .w-1\\/5 {
    width: 20%;
}
#login .w-10 {
    width: 2.5rem;
}
#login .w-11 {
    width: 2.75rem;
}
#login .w-2 {
    width: 0.5rem;
}
#login .w-20 {
    width: 5rem;
}
#login .w-28 {
    width: 7rem;
}
#login .w-3 {
    width: 0.75rem;
}
#login .w-3\\.5 {
    width: 0.875rem;
}
#login .w-3\\/4 {
    width: 75%;
}
#login .w-32 {
    width: 8rem;
}
#login .w-36 {
    width: 9rem;
}
#login .w-4 {
    width: 1rem;
}
#login .w-4\\.5 {
    width: 1.125rem;
}
#login .w-44 {
    width: 11rem;
}
#login .w-5 {
    width: 1.25rem;
}
#login .w-56 {
    width: 14rem;
}
#login .w-6\\.5 {
    width: 1.625rem;
}
#login .w-60 {
    width: 15rem;
}
#login .w-7 {
    width: 1.75rem;
}
#login .w-7\\.5 {
    width: 1.875rem;
}
#login .w-8 {
    width: 2rem;
}
#login .w-9 {
    width: 2.25rem;
}
#login .w-\\[1\\.125rem\\] {
    width: 1.125rem;
}
#login .w-\\[1\\.625rem\\] {
    width: 1.625rem;
}
#login .w-\\[1\\.875rem\\] {
    width: 1.875rem;
}
#login .w-\\[1px\\] {
    width: 1px;
}
#login .w-\\[var\\(--width\\)\\] {
    width: var(--width);
}
#login .w-fit {
    width: -moz-fit-content;
    width: fit-content;
}
#login .w-full {
    width: 100%;
}
#login .w-px {
    width: 1px;
}
#login .w-screen {
    width: 100vw;
}
#login .min-w-0 {
    min-width: 0px;
}
#login .min-w-20 {
    min-width: 5rem;
}
#login .min-w-9 {
    min-width: 2.25rem;
}
#login .min-w-\\[1\\.5rem\\] {
    min-width: 1.5rem;
}
#login .min-w-\\[3rem\\] {
    min-width: 3rem;
}
#login .min-w-\\[40px\\] {
    min-width: 40px;
}
#login .min-w-\\[56px\\] {
    min-width: 56px;
}
#login .min-w-\\[5rem\\] {
    min-width: 5rem;
}
#login .min-w-\\[8rem\\] {
    min-width: 8rem;
}
#login .min-w-\\[var\\(--radix-popover-trigger-width\\)\\] {
    min-width: var(--radix-popover-trigger-width);
}
#login .min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width);
}
#login .min-w-max {
    min-width: -moz-max-content;
    min-width: max-content;
}
#login .max-w-\\[400px\\] {
    max-width: 400px;
}
#login .max-w-\\[410px\\] {
    max-width: 410px;
}
#login .max-w-lg {
    max-width: 32rem;
}
#login .max-w-md {
    max-width: 28rem;
}
#login .flex-1 {
    flex: 1 1 0%;
}
#login .flex-none {
    flex: none;
}
#login .flex-shrink-0 {
    flex-shrink: 0;
}
#login .shrink {
    flex-shrink: 1;
}
#login .shrink-0 {
    flex-shrink: 0;
}
#login .grow {
    flex-grow: 1;
}
#login .grow-0 {
    flex-grow: 0;
}
#login .basis-full {
    flex-basis: 100%;
}
#login .table-auto {
    table-layout: auto;
}
#login .border-separate {
    border-collapse: separate;
}
#login .border-spacing-0 {
    --tw-border-spacing-x: 0px;
    --tw-border-spacing-y: 0px;
    border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
#login .origin-\\[0\\] {
    transform-origin: 0;
}
#login .-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .-translate-x-\\[calc\\(100\\%\\+0\\.75rem\\)\\] {
    --tw-translate-x: calc(calc(100% + 0.75rem) * -1);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .-translate-y-1 {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .-translate-y-4 {
    --tw-translate-y: -1rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .-translate-y-full {
    --tw-translate-y: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .translate-x-3 {
    --tw-translate-x: 0.75rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .rotate-45 {
    --tw-rotate: 45deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .scale-75 {
    --tw-scale-x: .75;
    --tw-scale-y: .75;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes caret-blink {
    0%,70%,100% {
        opacity: 1;
    }
    20%,50% {
        opacity: 0;
    }
}
#login .animate-caret-blink {
    animation: caret-blink 1.25s ease-out infinite;
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
#login .animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
#login .animate-spin {
    animation: spin 1s linear infinite;
}
#login .cursor-crosshair {
    cursor: crosshair;
}
#login .cursor-not-allowed {
    cursor: not-allowed;
}
#login .cursor-pointer {
    cursor: pointer;
}
#login .select-none {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
#login .resize-none {
    resize: none;
}
#login .resize {
    resize: both;
}
#login .auto-cols-max {
    grid-auto-columns: max-content;
}
#login .grid-flow-row {
    grid-auto-flow: row;
}
#login .grid-flow-col {
    grid-auto-flow: column;
}
#login .auto-rows-min {
    grid-auto-rows: min-content;
}
#login .grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
}
#login .grid-cols-\\[auto\\2c 1fr\\2c auto\\] {
    grid-template-columns: auto 1fr auto;
}
#login .grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
}
#login .flex-row {
    flex-direction: row;
}
#login .flex-col {
    flex-direction: column;
}
#login .flex-wrap {
    flex-wrap: wrap;
}
#login .content-center {
    align-content: center;
}
#login .content-start {
    align-content: flex-start;
}
#login .items-start {
    align-items: flex-start;
}
#login .items-end {
    align-items: flex-end;
}
#login .items-center {
    align-items: center;
}
#login .justify-start {
    justify-content: flex-start;
}
#login .justify-end {
    justify-content: flex-end;
}
#login .justify-center {
    justify-content: center;
}
#login .justify-between {
    justify-content: space-between;
}
#login .gap-0\\.25 {
    gap: 0.0625rem;
}
#login .gap-1 {
    gap: 0.25rem;
}
#login .gap-1\\.5 {
    gap: 0.375rem;
}
#login .gap-12 {
    gap: 3rem;
}
#login .gap-2 {
    gap: 0.5rem;
}
#login .gap-3 {
    gap: 0.75rem;
}
#login .gap-4 {
    gap: 1rem;
}
#login .gap-6 {
    gap: 1.5rem;
}
#login .gap-8 {
    gap: 2rem;
}
#login .gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
}
#login .gap-y-2 {
    row-gap: 0.5rem;
}
#login :is(.space-x-1 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
#login :is(.space-y-2 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
#login :is(.space-y-6 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
#login :is(.divide-x > :not([hidden]) ~ :not([hidden])) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
#login :is(.divide-y > :not([hidden]) ~ :not([hidden])) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
#login :is(.divide-border > :not([hidden]) ~ :not([hidden])) {
    border-color: hsl(var(--hsl-border));
}
#login .self-center {
    align-self: center;
}
#login .self-stretch {
    align-self: stretch;
}
#login .justify-self-start {
    justify-self: start;
}
#login .overflow-auto {
    overflow: auto;
}
#login .overflow-hidden {
    overflow: hidden;
}
#login .overflow-visible {
    overflow: visible;
}
#login .overflow-y-auto {
    overflow-y: auto;
}
#login .overflow-x-hidden {
    overflow-x: hidden;
}
#login .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
#login .whitespace-nowrap {
    white-space: nowrap;
}
#login .whitespace-pre-line {
    white-space: pre-line;
}
#login .text-nowrap {
    text-wrap: nowrap;
}
#login .break-normal {
    overflow-wrap: normal;
    word-break: normal;
}
#login .break-keep {
    word-break: keep-all;
}
#login .rounded {
    border-radius: 0.25rem;
}
#login .rounded-full {
    border-radius: 9999px;
}
#login .rounded-lg {
    border-radius: 0.5rem;
}
#login .rounded-none {
    border-radius: 0px;
}
#login .rounded-sm {
    border-radius: 0.125rem;
}
#login .rounded-xl {
    border-radius: 0.75rem;
}
#login .rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
#login .rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}
#login .border {
    border-width: 1px;
}
#login .border-0 {
    border-width: 0px;
}
#login .border-\\[1\\.5px\\] {
    border-width: 1.5px;
}
#login .border-\\[1px\\] {
    border-width: 1px;
}
#login .border-y {
    border-top-width: 1px;
    border-bottom-width: 1px;
}
#login .border-b {
    border-bottom-width: 1px;
}
#login .border-b-2 {
    border-bottom-width: 2px;
}
#login .border-l {
    border-left-width: 1px;
}
#login .border-r {
    border-right-width: 1px;
}
#login .border-t {
    border-top-width: 1px;
}
#login .border-solid {
    border-style: solid;
}
#login .border-dashed {
    border-style: dashed;
}
#login .border-active-foreground {
    border-color: hsl(var(--hsl-active-foreground));
}
#login .border-border {
    border-color: hsl(var(--hsl-border));
}
#login .border-border-inverse {
    border-color: hsl(var(--hsl-border-inverse));
}
#login .border-border-secondary {
    border-color: hsl(var(--hsl-border-secondary));
}
#login .border-button-blue-outline-border {
    border-color: hsl(var(--hsl-button-blue-outline-default-border));
}
#login .border-button-blue-surface-border {
    border-color: hsl(var(--hsl-button-blue-surface-default-border));
}
#login .border-button-cyan-outline-border {
    border-color: hsl(var(--hsl-button-cyan-outline-default-border));
}
#login .border-button-cyan-surface-border {
    border-color: hsl(var(--hsl-button-cyan-surface-default-border));
}
#login .border-button-green-outline-border {
    border-color: hsl(var(--hsl-button-green-outline-default-border));
}
#login .border-button-green-surface-border {
    border-color: hsl(var(--hsl-button-green-surface-default-border));
}
#login .border-button-inverse-outline-border {
    border-color: hsl(var(--hsl-button-inverse-outline-default-border));
}
#login .border-button-inverse-surface-border {
    border-color: hsl(var(--hsl-button-inverse-surface-default-border));
}
#login .border-button-neutral-outline-border {
    border-color: hsl(var(--hsl-button-neutral-outline-default-border));
}
#login .border-button-neutral-surface-border {
    border-color: hsl(var(--hsl-button-neutral-surface-default-border));
}
#login .border-button-primary-outline-border {
    border-color: hsl(var(--hsl-button-primary-outline-default-border));
}
#login .border-button-primary-surface-border {
    border-color: hsl(var(--hsl-button-primary-surface-default-border));
}
#login .border-button-purple-outline-border {
    border-color: hsl(var(--hsl-button-purple-outline-default-border));
}
#login .border-button-purple-surface-border {
    border-color: hsl(var(--hsl-button-purple-surface-default-border));
}
#login .border-button-red-outline-border {
    border-color: hsl(var(--hsl-button-red-outline-default-border));
}
#login .border-button-red-surface-border {
    border-color: hsl(var(--hsl-button-red-surface-default-border));
}
#login .border-button-yellow-outline-border {
    border-color: hsl(var(--hsl-button-yellow-outline-default-border));
}
#login .border-button-yellow-surface-border {
    border-color: hsl(var(--hsl-button-yellow-surface-default-border));
}
#login .border-chip-blue-border {
    border-color: hsl(var(--hsl-chip-blue-border));
}
#login .border-error-accent {
    border-color: hsl(var(--hsl-error-accent));
}
#login .border-error-border {
    border-color: hsl(var(--hsl-error-border));
}
#login .border-foreground {
    border-color: hsl(var(--hsl-foreground));
}
#login .border-inactive {
    border-color: hsl(var(--hsl-inactive));
}
#login .border-info-border {
    border-color: hsl(var(--hsl-info-border));
}
#login .border-sidebar-border {
    border-color: hsl(var(--hsl-sidebar-border));
}
#login .border-success-accent {
    border-color: hsl(var(--hsl-success-accent));
}
#login .border-success-border {
    border-color: hsl(var(--hsl-success-border));
}
#login .border-switch-off-disabled {
    border-color: hsl(var(--hsl-switch-off-disabled));
}
#login .border-tag-blue-border {
    border-color: hsl(var(--hsl-tag-blue-border));
}
#login .border-tag-cyan-border {
    border-color: hsl(var(--hsl-tag-cyan-border));
}
#login .border-tag-fuchsia-border {
    border-color: hsl(var(--hsl-tag-fuchsia-border));
}
#login .border-tag-green-border {
    border-color: hsl(var(--hsl-tag-green-border));
}
#login .border-tag-neutral-border {
    border-color: hsl(var(--hsl-tag-neutral-border));
}
#login .border-tag-orange-border {
    border-color: hsl(var(--hsl-tag-orange-border));
}
#login .border-tag-purple-border {
    border-color: hsl(var(--hsl-tag-purple-border));
}
#login .border-tag-red-border {
    border-color: hsl(var(--hsl-tag-red-border));
}
#login .border-tag-subtle-border {
    border-color: hsl(var(--hsl-tag-subtle-border));
}
#login .border-tag-teal-border {
    border-color: hsl(var(--hsl-tag-teal-border));
}
#login .border-tag-yellow-border {
    border-color: hsl(var(--hsl-tag-yellow-border));
}
#login .border-transparent {
    border-color: transparent;
}
#login .border-warning-accent {
    border-color: hsl(var(--hsl-warning-accent));
}
#login .border-warning-border {
    border-color: hsl(var(--hsl-warning-border));
}
#login .border-b-border {
    border-bottom-color: hsl(var(--hsl-border));
}
#login .border-t-border {
    border-top-color: hsl(var(--hsl-border));
}
#login .\\!bg-active-foreground {
    background-color: hsl(var(--hsl-active-foreground)) !important;
}
#login .\\!bg-skeleton {
    background-color: hsl(var(--hsl-skeleton)) !important;
}
#login .bg-active {
    background-color: hsl(var(--hsl-active));
}
#login .bg-active-foreground {
    background-color: hsl(var(--hsl-active-foreground));
}
#login .bg-border {
    background-color: hsl(var(--hsl-border));
}
#login .bg-button-blue-soft {
    background-color: hsl(var(--hsl-button-blue-soft-default-background));
}
#login .bg-button-blue-solid {
    background-color: hsl(var(--hsl-button-blue-solid-default-background));
}
#login .bg-button-blue-surface {
    background-color: hsl(var(--hsl-button-blue-surface-default-background));
}
#login .bg-button-cyan-soft {
    background-color: hsl(var(--hsl-button-cyan-soft-default-background));
}
#login .bg-button-cyan-solid {
    background-color: hsl(var(--hsl-button-cyan-solid-default-background));
}
#login .bg-button-cyan-surface {
    background-color: hsl(var(--hsl-button-cyan-surface-default-background));
}
#login .bg-button-green-soft {
    background-color: hsl(var(--hsl-button-green-soft-default-background));
}
#login .bg-button-green-solid {
    background-color: hsl(var(--hsl-button-green-solid-default-background));
}
#login .bg-button-green-surface {
    background-color: hsl(var(--hsl-button-green-surface-default-background));
}
#login .bg-button-inverse-soft {
    background-color: hsl(var(--hsl-button-inverse-soft-default-background));
}
#login .bg-button-inverse-solid {
    background-color: hsl(var(--hsl-button-inverse-solid-default-background));
}
#login .bg-button-inverse-surface {
    background-color: hsl(var(--hsl-button-inverse-surface-default-background));
}
#login .bg-button-neutral-soft {
    background-color: hsl(var(--hsl-button-neutral-soft-default-background));
}
#login .bg-button-neutral-solid {
    background-color: hsl(var(--hsl-button-neutral-solid-default-background));
}
#login .bg-button-neutral-surface {
    background-color: hsl(var(--hsl-button-neutral-surface-default-background));
}
#login .bg-button-primary-soft {
    background-color: hsl(var(--hsl-button-primary-soft-default-background));
}
#login .bg-button-primary-solid {
    background-color: hsl(var(--hsl-button-primary-solid-default-background));
}
#login .bg-button-primary-surface {
    background-color: hsl(var(--hsl-button-primary-surface-default-background));
}
#login .bg-button-purple-soft {
    background-color: hsl(var(--hsl-button-purple-soft-default-background));
}
#login .bg-button-purple-solid {
    background-color: hsl(var(--hsl-button-purple-solid-default-background));
}
#login .bg-button-purple-surface {
    background-color: hsl(var(--hsl-button-purple-surface-default-background));
}
#login .bg-button-red-soft {
    background-color: hsl(var(--hsl-button-red-soft-default-background));
}
#login .bg-button-red-solid {
    background-color: hsl(var(--hsl-button-red-solid-default-background));
}
#login .bg-button-red-surface {
    background-color: hsl(var(--hsl-button-red-surface-default-background));
}
#login .bg-button-yellow-soft {
    background-color: hsl(var(--hsl-button-yellow-soft-default-background));
}
#login .bg-button-yellow-solid {
    background-color: hsl(var(--hsl-button-yellow-solid-default-background));
}
#login .bg-button-yellow-surface {
    background-color: hsl(var(--hsl-button-yellow-surface-default-background));
}
#login .bg-card {
    background-color: hsl(var(--hsl-card));
}
#login .bg-card-inverse {
    background-color: hsl(var(--hsl-card-inverse));
}
#login .bg-card-quaternary {
    background-color: hsl(var(--hsl-card-quaternary));
}
#login .bg-card-secondary {
    background-color: hsl(var(--hsl-card-secondary));
}
#login .bg-card-tertiary {
    background-color: hsl(var(--hsl-card-tertiary));
}
#login .bg-chip-blue {
    background-color: hsl(var(--hsl-chip-blue));
}
#login .bg-error {
    background-color: hsl(var(--hsl-error));
}
#login .bg-error-accent {
    background-color: hsl(var(--hsl-error-accent));
}
#login .bg-foreground {
    background-color: hsl(var(--hsl-foreground));
}
#login .bg-inactive {
    background-color: hsl(var(--hsl-inactive));
}
#login .bg-inactive-subtle {
    background-color: hsl(var(--hsl-inactive-subtle));
}
#login .bg-info {
    background-color: hsl(var(--hsl-info));
}
#login .bg-lozenge-blue {
    background-color: hsl(var(--hsl-lozenge-blue));
}
#login .bg-lozenge-cyan {
    background-color: hsl(var(--hsl-lozenge-cyan));
}
#login .bg-lozenge-fuchsia {
    background-color: hsl(var(--hsl-lozenge-fuchsia));
}
#login .bg-lozenge-green {
    background-color: hsl(var(--hsl-lozenge-green));
}
#login .bg-lozenge-neutral {
    background-color: hsl(var(--hsl-lozenge-neutral));
}
#login .bg-lozenge-neutral-subtle {
    background-color: hsl(var(--hsl-lozenge-neutral-subtle));
}
#login .bg-lozenge-orange {
    background-color: hsl(var(--hsl-lozenge-orange));
}
#login .bg-lozenge-purple {
    background-color: hsl(var(--hsl-lozenge-purple));
}
#login .bg-lozenge-red {
    background-color: hsl(var(--hsl-lozenge-red));
}
#login .bg-lozenge-teal {
    background-color: hsl(var(--hsl-lozenge-teal));
}
#login .bg-lozenge-yellow {
    background-color: hsl(var(--hsl-lozenge-yellow));
}
#login .bg-neutral-10 {
    background-color: hsl(var(--hsl-neutral-10));
}
#login .bg-neutral-5 {
    background-color: hsl(var(--hsl-neutral-5));
}
#login .bg-overlay\\/40 {
    background-color: hsl(var(--hsl-overlay) / 0.4);
}
#login .bg-page {
    background-color: hsl(var(--hsl-page));
}
#login .bg-sidebar {
    background-color: hsl(var(--hsl-sidebar));
}
#login .bg-sidebar-active {
    background-color: hsl(var(--hsl-sidebar-active));
}
#login .bg-skeleton {
    background-color: hsl(var(--hsl-skeleton));
}
#login .bg-success {
    background-color: hsl(var(--hsl-success));
}
#login .bg-success-accent {
    background-color: hsl(var(--hsl-success-accent));
}
#login .bg-switch-off {
    background-color: hsl(var(--hsl-switch-off));
}
#login .bg-switch-off-disabled {
    background-color: hsl(var(--hsl-switch-off-disabled));
}
#login .bg-switch-off-foreground {
    background-color: hsl(var(--hsl-switch-off-foreground));
}
#login .bg-switch-on {
    background-color: hsl(var(--hsl-switch-on));
}
#login .bg-switch-on-disabled {
    background-color: hsl(var(--hsl-switch-on-disabled));
}
#login .bg-switch-on-disabled-foreground {
    background-color: hsl(var(--hsl-switch-on-disabled-foreground));
}
#login .bg-switch-on-foreground {
    background-color: hsl(var(--hsl-switch-on-foreground));
}
#login .bg-tag-blue {
    background-color: hsl(var(--hsl-tag-blue));
}
#login .bg-tag-cyan {
    background-color: hsl(var(--hsl-tag-cyan));
}
#login .bg-tag-fuchsia {
    background-color: hsl(var(--hsl-tag-fuchsia));
}
#login .bg-tag-green {
    background-color: hsl(var(--hsl-tag-green));
}
#login .bg-tag-neutral {
    background-color: hsl(var(--hsl-tag-neutral));
}
#login .bg-tag-orange {
    background-color: hsl(var(--hsl-tag-orange));
}
#login .bg-tag-purple {
    background-color: hsl(var(--hsl-tag-purple));
}
#login .bg-tag-red {
    background-color: hsl(var(--hsl-tag-red));
}
#login .bg-tag-subtle {
    background-color: hsl(var(--hsl-tag-subtle));
}
#login .bg-tag-teal {
    background-color: hsl(var(--hsl-tag-teal));
}
#login .bg-tag-yellow {
    background-color: hsl(var(--hsl-tag-yellow));
}
#login .bg-transparent {
    background-color: transparent;
}
#login .bg-warning {
    background-color: hsl(var(--hsl-warning));
}
#login .bg-warning-accent {
    background-color: hsl(var(--hsl-warning-accent));
}
#login .fill-card-tertiary {
    fill: hsl(var(--hsl-card-tertiary));
}
#login .fill-foreground-secondary {
    fill: hsl(var(--hsl-foreground-secondary));
}
#login .fill-inactive-subtle {
    fill: hsl(var(--hsl-inactive-subtle));
}
#login .fill-transparent {
    fill: transparent;
}
#login .stroke-border {
    stroke: hsl(var(--hsl-border));
}
#login .stroke-1 {
    stroke-width: 1;
}
#login .stroke-2 {
    stroke-width: 2;
}
#login .p-0 {
    padding: 0px;
}
#login .p-0\\.5 {
    padding: 0.125rem;
}
#login .p-1 {
    padding: 0.25rem;
}
#login .p-10 {
    padding: 2.5rem;
}
#login .p-2 {
    padding: 0.5rem;
}
#login .p-3 {
    padding: 0.75rem;
}
#login .p-4 {
    padding: 1rem;
}
#login .p-6 {
    padding: 1.5rem;
}
#login .p-8 {
    padding: 2rem;
}
#login .px-0 {
    padding-left: 0px;
    padding-right: 0px;
}
#login .px-0\\.75 {
    padding-left: 0.1875rem;
    padding-right: 0.1875rem;
}
#login .px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
#login .px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
}
#login .px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
}
#login .px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
#login .px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
#login .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
#login .px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
#login .px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
#login .px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
}
#login .py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
#login .py-0\\.75 {
    padding-top: 0.1875rem;
    padding-bottom: 0.1875rem;
}
#login .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
#login .py-1\\.25 {
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
}
#login .py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
#login .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
#login .py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
}
#login .py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
#login .py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
#login .py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}
#login .py-\\[0\\.375rem\\] {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
#login .pb-4 {
    padding-bottom: 1rem;
}
#login .pl-1 {
    padding-left: 0.25rem;
}
#login .pl-2 {
    padding-left: 0.5rem;
}
#login .pl-3 {
    padding-left: 0.75rem;
}
#login .pl-4 {
    padding-left: 1rem;
}
#login .pl-6 {
    padding-left: 1.5rem;
}
#login .pl-8 {
    padding-left: 2rem;
}
#login .pl-9 {
    padding-left: 2.25rem;
}
#login .pr-1 {
    padding-right: 0.25rem;
}
#login .pr-2 {
    padding-right: 0.5rem;
}
#login .pr-4 {
    padding-right: 1rem;
}
#login .pt-1\\.5 {
    padding-top: 0.375rem;
}
#login .pt-6 {
    padding-top: 1.5rem;
}
#login .text-left {
    text-align: left;
}
#login .text-center {
    text-align: center;
}
#login .font-sans {
    font-family: DM Sans, Noto Sans JP, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
#login .text-2xl {
    font-size: 1.5rem;
    line-height: 2.25rem;
}
#login .text-\\[\\.625rem\\] {
    font-size: .625rem;
}
#login .text-\\[\\.75rem\\] {
    font-size: .75rem;
}
#login .text-\\[\\.875rem\\] {
    font-size: .875rem;
}
#login .text-\\[1\\.25rem\\] {
    font-size: 1.25rem;
}
#login .text-\\[1\\.5rem\\] {
    font-size: 1.5rem;
}
#login .text-\\[2rem\\] {
    font-size: 2rem;
}
#login .text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}
#login .text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}
#login .text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
#login .text-xl {
    font-size: 1.25rem;
    line-height: 1.875rem;
}
#login .text-xs {
    font-size: 0.75rem;
    line-height: 1.1rem;
}
#login .font-medium {
    font-weight: 500;
}
#login .font-normal {
    font-weight: 400;
}
#login .leading-none {
    line-height: 1;
}
#login .text-active-foreground {
    color: hsl(var(--hsl-active-foreground));
}
#login .text-active-foreground-hover {
    color: hsl(var(--hsl-active-foreground-hover));
}
#login .text-button-blue-ghost-foreground {
    color: hsl(var(--hsl-button-blue-ghost-default-foreground));
}
#login .text-button-blue-outline-foreground {
    color: hsl(var(--hsl-button-blue-outline-default-foreground));
}
#login .text-button-blue-soft-foreground {
    color: hsl(var(--hsl-button-blue-soft-default-foreground));
}
#login .text-button-blue-solid-foreground {
    color: hsl(var(--hsl-button-blue-solid-default-foreground));
}
#login .text-button-blue-surface-foreground {
    color: hsl(var(--hsl-button-blue-surface-default-foreground));
}
#login .text-button-cyan-ghost-foreground {
    color: hsl(var(--hsl-button-cyan-ghost-default-foreground));
}
#login .text-button-cyan-outline-foreground {
    color: hsl(var(--hsl-button-cyan-outline-default-foreground));
}
#login .text-button-cyan-soft-foreground {
    color: hsl(var(--hsl-button-cyan-soft-default-foreground));
}
#login .text-button-cyan-solid-foreground {
    color: hsl(var(--hsl-button-cyan-solid-default-foreground));
}
#login .text-button-cyan-surface-foreground {
    color: hsl(var(--hsl-button-cyan-surface-default-foreground));
}
#login .text-button-disabled-foreground-actionbutton {
    color: hsl(var(--hsl-button-disabled-foreground-actionbutton));
}
#login .text-button-green-ghost-foreground {
    color: hsl(var(--hsl-button-green-ghost-default-foreground));
}
#login .text-button-green-outline-foreground {
    color: hsl(var(--hsl-button-green-outline-default-foreground));
}
#login .text-button-green-soft-foreground {
    color: hsl(var(--hsl-button-green-soft-default-foreground));
}
#login .text-button-green-solid-foreground {
    color: hsl(var(--hsl-button-green-solid-default-foreground));
}
#login .text-button-green-surface-foreground {
    color: hsl(var(--hsl-button-green-surface-default-foreground));
}
#login .text-button-inverse-ghost-foreground {
    color: hsl(var(--hsl-button-inverse-ghost-default-foreground));
}
#login .text-button-inverse-outline-foreground {
    color: hsl(var(--hsl-button-inverse-outline-default-foreground));
}
#login .text-button-inverse-soft-foreground {
    color: hsl(var(--hsl-button-inverse-soft-default-foreground));
}
#login .text-button-inverse-solid-foreground {
    color: hsl(var(--hsl-button-inverse-solid-default-foreground));
}
#login .text-button-inverse-surface-foreground {
    color: hsl(var(--hsl-button-inverse-surface-default-foreground));
}
#login .text-button-neutral-ghost-foreground {
    color: hsl(var(--hsl-button-neutral-ghost-default-foreground));
}
#login .text-button-neutral-outline-foreground {
    color: hsl(var(--hsl-button-neutral-outline-default-foreground));
}
#login .text-button-neutral-soft-foreground {
    color: hsl(var(--hsl-button-neutral-soft-default-foreground));
}
#login .text-button-neutral-solid-foreground {
    color: hsl(var(--hsl-button-neutral-solid-default-foreground));
}
#login .text-button-neutral-surface-foreground {
    color: hsl(var(--hsl-button-neutral-surface-default-foreground));
}
#login .text-button-primary-ghost-foreground {
    color: hsl(var(--hsl-button-primary-ghost-default-foreground));
}
#login .text-button-primary-outline-foreground {
    color: hsl(var(--hsl-button-primary-outline-default-foreground));
}
#login .text-button-primary-soft-foreground {
    color: hsl(var(--hsl-button-primary-soft-default-foreground));
}
#login .text-button-primary-solid-foreground {
    color: hsl(var(--hsl-button-primary-solid-default-foreground));
}
#login .text-button-primary-surface-foreground {
    color: hsl(var(--hsl-button-primary-surface-default-foreground));
}
#login .text-button-purple-ghost-foreground {
    color: hsl(var(--hsl-button-purple-ghost-default-foreground));
}
#login .text-button-purple-outline-foreground {
    color: hsl(var(--hsl-button-purple-outline-default-foreground));
}
#login .text-button-purple-soft-foreground {
    color: hsl(var(--hsl-button-purple-soft-default-foreground));
}
#login .text-button-purple-solid-foreground {
    color: hsl(var(--hsl-button-purple-solid-default-foreground));
}
#login .text-button-purple-surface-foreground {
    color: hsl(var(--hsl-button-purple-surface-default-foreground));
}
#login .text-button-red-ghost-foreground {
    color: hsl(var(--hsl-button-red-ghost-default-foreground));
}
#login .text-button-red-outline-foreground {
    color: hsl(var(--hsl-button-red-outline-default-foreground));
}
#login .text-button-red-soft-foreground {
    color: hsl(var(--hsl-button-red-soft-default-foreground));
}
#login .text-button-red-solid-foreground {
    color: hsl(var(--hsl-button-red-solid-default-foreground));
}
#login .text-button-red-surface-foreground {
    color: hsl(var(--hsl-button-red-surface-default-foreground));
}
#login .text-button-yellow-ghost-foreground {
    color: hsl(var(--hsl-button-yellow-ghost-default-foreground));
}
#login .text-button-yellow-outline-foreground {
    color: hsl(var(--hsl-button-yellow-outline-default-foreground));
}
#login .text-button-yellow-soft-foreground {
    color: hsl(var(--hsl-button-yellow-soft-default-foreground));
}
#login .text-button-yellow-solid-foreground {
    color: hsl(var(--hsl-button-yellow-solid-default-foreground));
}
#login .text-button-yellow-surface-foreground {
    color: hsl(var(--hsl-button-yellow-surface-default-foreground));
}
#login .text-chip-blue-foreground {
    color: hsl(var(--hsl-chip-blue-foreground));
}
#login .text-error-accent {
    color: hsl(var(--hsl-error-accent));
}
#login .text-error-foreground {
    color: hsl(var(--hsl-error-foreground));
}
#login .text-foreground {
    color: hsl(var(--hsl-foreground));
}
#login .text-foreground-inverse {
    color: hsl(var(--hsl-foreground-inverse));
}
#login .text-foreground-secondary {
    color: hsl(var(--hsl-foreground-secondary));
}
#login .text-foreground-tertiary {
    color: hsl(var(--hsl-foreground-tertiary));
}
#login .text-inactive {
    color: hsl(var(--hsl-inactive));
}
#login .text-inactive-foreground {
    color: hsl(var(--hsl-inactive-foreground));
}
#login .text-inactive-readonly {
    color: hsl(var(--hsl-inactive-readonly));
}
#login .text-info-accent {
    color: hsl(var(--hsl-info-accent));
}
#login .text-info-foreground {
    color: hsl(var(--hsl-info-foreground));
}
#login .text-page {
    color: hsl(var(--hsl-page));
}
#login .text-purple-70 {
    color: hsl(var(--hsl-purple-70));
}
#login .text-sidebar-foreground {
    color: hsl(var(--hsl-sidebar-foreground));
}
#login .text-sidebar-foreground-secondary {
    color: hsl(var(--hsl-sidebar-foreground-secondary));
}
#login .text-success-accent {
    color: hsl(var(--hsl-success-accent));
}
#login .text-success-foreground {
    color: hsl(var(--hsl-success-foreground));
}
#login .text-textlink {
    color: hsl(var(--hsl-textlink));
}
#login .text-warning-accent {
    color: hsl(var(--hsl-warning-accent));
}
#login .text-warning-foreground {
    color: hsl(var(--hsl-warning-foreground));
}
#login .line-through {
    text-decoration-line: line-through;
}
#login .decoration-foreground {
    text-decoration-color: hsl(var(--hsl-foreground));
}
#login .opacity-0 {
    opacity: 0;
}
#login .opacity-30 {
    opacity: 0.3;
}
#login .shadow {
    --tw-shadow: var(--shadow);
    --tw-shadow-colored: var(--shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#login .shadow-md {
    --tw-shadow: var(--shadow-md);
    --tw-shadow-colored: var(--shadow-md);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#login .shadow-sm {
    --tw-shadow: var(--shadow-sm);
    --tw-shadow-colored: var(--shadow-sm);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#login .outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
#login .outline {
    outline-style: solid;
}
#login .ring {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .ring-1 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .ring-4 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .ring-inset {
    --tw-ring-inset: inset;
}
#login .ring-active {
    --tw-ring-color: hsl(var(--hsl-active));
}
#login .ring-active-foreground\\/25 {
    --tw-ring-color: hsl(var(--hsl-active-foreground) / 0.25);
}
#login .ring-button-blue-focus {
    --tw-ring-color: hsl(var(--hsl-button-blue-focus));
}
#login .ring-button-cyan-focus {
    --tw-ring-color: hsl(var(--hsl-button-cyan-focus));
}
#login .ring-button-green-focus {
    --tw-ring-color: hsl(var(--hsl-button-green-focus));
}
#login .ring-button-inverse-focus {
    --tw-ring-color: hsl(var(--hsl-button-inverse-focus));
}
#login .ring-button-neutral-focus {
    --tw-ring-color: hsl(var(--hsl-button-neutral-focus));
}
#login .ring-button-primary-focus {
    --tw-ring-color: hsl(var(--hsl-button-primary-focus));
}
#login .ring-button-purple-focus {
    --tw-ring-color: hsl(var(--hsl-button-purple-focus));
}
#login .ring-button-red-focus {
    --tw-ring-color: hsl(var(--hsl-button-red-focus));
}
#login .ring-button-yellow-focus {
    --tw-ring-color: hsl(var(--hsl-button-yellow-focus));
}
#login .ring-focus {
    --tw-ring-color: hsl(var(--hsl-focus));
}
#login .ring-offset-0 {
    --tw-ring-offset-width: 0px;
}
#login .ring-offset-2 {
    --tw-ring-offset-width: 2px;
}
#login .ring-offset-card {
    --tw-ring-offset-color: hsl(var(--hsl-card));
}
#login .ring-offset-page {
    --tw-ring-offset-color: hsl(var(--hsl-page));
}
#login .ring-offset-sidebar {
    --tw-ring-offset-color: hsl(var(--hsl-sidebar));
}
#login .drop-shadow {
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#login .invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#login .filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#login .transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
#login .transition-\\[height\\] {
    transition-property: height;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
#login .transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
#login .transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
#login .transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
#login .transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
#login .delay-300 {
    transition-delay: 300ms;
}
#login .duration-1000 {
    transition-duration: 1000ms;
}
#login .duration-300 {
    transition-duration: 300ms;
}
#login .ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter {
    from {
        opacity: var(--tw-enter-opacity, 1);
        transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
    }
}
@keyframes exit {
    to {
        opacity: var(--tw-exit-opacity, 1);
        transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
    }
}
#login .duration-1000 {
    animation-duration: 1000ms;
}
#login .duration-300 {
    animation-duration: 300ms;
}
#login .delay-300 {
    animation-delay: 300ms;
}
#login .ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
#login .scrollbar-none {
    scrollbar-width: none;
}
#login .scrollbar-none::-webkit-scrollbar {
    display: none;
}
#login .\\@container\\/lozenge {
    container-type: inline-size;
    container-name: lozenge;
}
#login .placeholder\\:text-foreground-secondary::-moz-placeholder {
    color: hsl(var(--hsl-foreground-secondary));
}
#login .placeholder\\:text-foreground-secondary::placeholder {
    color: hsl(var(--hsl-foreground-secondary));
}
#login .before\\:block::before {
    content: var(--tw-content);
    display: block;
}
#login .before\\:h-full::before {
    content: var(--tw-content);
    height: 100%;
}
#login .before\\:w-full::before {
    content: var(--tw-content);
    width: 100%;
}
#login .before\\:rounded::before {
    content: var(--tw-content);
    border-radius: 0.25rem;
}
#login .before\\:bg-error-skeleton::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-error-skeleton));
}
#login .before\\:bg-info-skeleton::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-info-skeleton));
}
#login .before\\:bg-sidebar-skeleton::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-sidebar-skeleton));
}
#login .before\\:bg-skeleton::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-skeleton));
}
#login .before\\:bg-skeleton-blue::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-skeleton-blue));
}
#login .before\\:bg-skeleton-inverse::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-skeleton-inverse));
}
#login .before\\:bg-success-skeleton::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-success-skeleton));
}
#login .before\\:bg-warning-skeleton::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-warning-skeleton));
}
#login .before\\:content-\\[\\'\\'\\]::before {
    --tw-content: '';
    content: var(--tw-content);
}
#login .after\\:absolute::after {
    content: var(--tw-content);
    position: absolute;
}
#login .after\\:-bottom-1::after {
    content: var(--tw-content);
    bottom: -0.25rem;
}
#login .after\\:left-2::after {
    content: var(--tw-content);
    left: 0.5rem;
}
#login .after\\:left-3::after {
    content: var(--tw-content);
    left: 0.75rem;
}
#login .after\\:left-4::after {
    content: var(--tw-content);
    left: 1rem;
}
#login .after\\:left-5::after {
    content: var(--tw-content);
    left: 1.25rem;
}
#login .after\\:left-6::after {
    content: var(--tw-content);
    left: 1.5rem;
}
#login .after\\:right-0::after {
    content: var(--tw-content);
    right: 0px;
}
#login .after\\:right-2::after {
    content: var(--tw-content);
    right: 0.5rem;
}
#login .after\\:right-3::after {
    content: var(--tw-content);
    right: 0.75rem;
}
#login .after\\:right-4::after {
    content: var(--tw-content);
    right: 1rem;
}
#login .after\\:right-5::after {
    content: var(--tw-content);
    right: 1.25rem;
}
#login .after\\:right-6::after {
    content: var(--tw-content);
    right: 1.5rem;
}
#login .after\\:top-1\\/2::after {
    content: var(--tw-content);
    top: 50%;
}
#login .after\\:h-1::after {
    content: var(--tw-content);
    height: 0.25rem;
}
#login .after\\:h-\\[calc\\(100\\%-1rem\\)\\]::after {
    content: var(--tw-content);
    height: calc(100% - 1rem);
}
#login .after\\:-translate-y-1\\/2::after {
    content: var(--tw-content);
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .after\\:rounded-\\[1px\\]::after {
    content: var(--tw-content);
    border-radius: 1px;
}
#login .after\\:border-r::after {
    content: var(--tw-content);
    border-right-width: 1px;
}
#login .after\\:border-r-border::after {
    content: var(--tw-content);
    border-right-color: hsl(var(--hsl-border));
}
#login .after\\:content-\\[\\'\\'\\]::after {
    --tw-content: '';
    content: var(--tw-content);
}
#login .first\\:hidden:first-child {
    display: none;
}
#login .first\\:rounded-l:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
#login .first\\:rounded-l-md:first-child {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}
#login .first\\:rounded-t:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
#login .first\\:rounded-tl:first-child {
    border-top-left-radius: 0.25rem;
}
#login .first\\:rounded-tr:first-child {
    border-top-right-radius: 0.25rem;
}
#login .first\\:rounded-tr-none:first-child {
    border-top-right-radius: 0px;
}
#login .first\\:border-l:first-child {
    border-left-width: 1px;
}
#login .first\\:border-r:first-child {
    border-right-width: 1px;
}
#login .first\\:border-t-0:first-child {
    border-top-width: 0px;
}
#login .first\\:pr-0:first-child {
    padding-right: 0px;
}
#login .first\\:pt-0:first-child {
    padding-top: 0px;
}
#login .last\\:mb-3:last-child {
    margin-bottom: 0.75rem;
}
#login .last\\:rounded-b:last-child {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
#login .last\\:rounded-r:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}
#login .last\\:rounded-r-md:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}
#login .last\\:rounded-bl:last-child {
    border-bottom-left-radius: 0.25rem;
}
#login .last\\:rounded-bl-none:last-child {
    border-bottom-left-radius: 0px;
}
#login .last\\:rounded-br:last-child {
    border-bottom-right-radius: 0.25rem;
}
#login .last\\:border-0:last-child {
    border-width: 0px;
}
#login .last\\:border-l:last-child {
    border-left-width: 1px;
}
#login .last\\:pb-0:last-child {
    padding-bottom: 0px;
}
#login .last\\:after\\:hidden:last-child::after {
    content: var(--tw-content);
    display: none;
}
#login :is(.group\\/row:first-child .group-first\\/row\\:first\\:rounded-tl:first-child) {
    border-top-left-radius: 0.25rem;
}
#login :is(.group\\/row:first-child .group-first\\/row\\:last\\:rounded-tr:last-child) {
    border-top-right-radius: 0.25rem;
}
#login :is(.group\\/row:last-child .group-last\\/row\\:border-none) {
    border-style: none;
}
#login :is(.group\\/row:last-child .group-last\\/row\\:first\\:rounded-bl:first-child) {
    border-bottom-left-radius: 0.25rem;
}
#login :is(.group\\/row:last-child .group-last\\/row\\:last\\:rounded-br:last-child) {
    border-bottom-right-radius: 0.25rem;
}
#login :is(.group:hover .group-hover\\:border-b-4) {
    border-bottom-width: 4px;
}
#login :is(.group:hover .group-hover\\:\\!border-active-foreground) {
    border-color: hsl(var(--hsl-active-foreground)) !important;
}
#login :is(.group:hover .group-hover\\:border-error-secondary) {
    border-color: hsl(var(--hsl-error-secondary));
}
#login :is(.group:hover .group-hover\\:border-inactive-foreground) {
    border-color: hsl(var(--hsl-inactive-foreground));
}
#login :is(.group:hover .group-hover\\:border-success-secondary) {
    border-color: hsl(var(--hsl-success-secondary));
}
#login :is(.group:hover .group-hover\\:border-warning-secondary) {
    border-color: hsl(var(--hsl-warning-secondary));
}
#login :is(.group:hover .group-hover\\:\\!bg-active) {
    background-color: hsl(var(--hsl-active)) !important;
}
#login :is(.group:hover .group-hover\\:bg-error-secondary) {
    background-color: hsl(var(--hsl-error-secondary));
}
#login :is(.group:hover .group-hover\\:bg-inactive-foreground) {
    background-color: hsl(var(--hsl-inactive-foreground));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-blue-hover) {
    background-color: hsl(var(--hsl-lozenge-blue-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-cyan-hover) {
    background-color: hsl(var(--hsl-lozenge-cyan-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-fuchsia-hover) {
    background-color: hsl(var(--hsl-lozenge-fuchsia-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-green-hover) {
    background-color: hsl(var(--hsl-lozenge-green-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-neutral-hover) {
    background-color: hsl(var(--hsl-lozenge-neutral-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-neutral-subtle-hover) {
    background-color: hsl(var(--hsl-lozenge-neutral-subtle-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-orange-hover) {
    background-color: hsl(var(--hsl-lozenge-orange-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-purple-hover) {
    background-color: hsl(var(--hsl-lozenge-purple-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-red-hover) {
    background-color: hsl(var(--hsl-lozenge-red-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-teal-hover) {
    background-color: hsl(var(--hsl-lozenge-teal-hover));
}
#login :is(.group:hover .group-hover\\:bg-lozenge-yellow-hover) {
    background-color: hsl(var(--hsl-lozenge-yellow-hover));
}
#login :is(.group:hover .group-hover\\:bg-success-secondary) {
    background-color: hsl(var(--hsl-success-secondary));
}
#login :is(.group:hover .group-hover\\:bg-warning-secondary) {
    background-color: hsl(var(--hsl-warning-secondary));
}
#login :is(.group\\/checkbox-root:hover .group-hover\\/checkbox-root\\:text-inactive-foreground) {
    color: hsl(var(--hsl-inactive-foreground));
}
#login :is(.group:hover .group-hover\\:\\!text-active-foreground) {
    color: hsl(var(--hsl-active-foreground)) !important;
}
#login :is(.group:hover .group-hover\\:text-active-foreground) {
    color: hsl(var(--hsl-active-foreground));
}
#login :is(.group:hover .group-hover\\:text-foreground) {
    color: hsl(var(--hsl-foreground));
}
#login :is(.group\\/input:hover .group-hover\\/input\\:ring-1) {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login :is(.group\\/input:hover .group-hover\\/input\\:ring-border-tertiary) {
    --tw-ring-color: hsl(var(--hsl-border-tertiary));
}
#login :is(.group:active .group-active\\:bg-lozenge-blue-press) {
    background-color: hsl(var(--hsl-lozenge-blue-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-cyan-press) {
    background-color: hsl(var(--hsl-lozenge-cyan-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-fuchsia-press) {
    background-color: hsl(var(--hsl-lozenge-fuchsia-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-green-press) {
    background-color: hsl(var(--hsl-lozenge-green-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-neutral-press) {
    background-color: hsl(var(--hsl-lozenge-neutral-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-neutral-subtle-press) {
    background-color: hsl(var(--hsl-lozenge-neutral-subtle-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-orange-press) {
    background-color: hsl(var(--hsl-lozenge-orange-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-purple-press) {
    background-color: hsl(var(--hsl-lozenge-purple-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-red-press) {
    background-color: hsl(var(--hsl-lozenge-red-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-teal-press) {
    background-color: hsl(var(--hsl-lozenge-teal-press));
}
#login :is(.group:active .group-active\\:bg-lozenge-yellow-press) {
    background-color: hsl(var(--hsl-lozenge-yellow-press));
}
#login :is(.group\\/checkbox-indicator:disabled .group-disabled\\/checkbox-indicator\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.group\\/selectable-card:disabled .group-disabled\\/selectable-card\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.group:disabled .group-disabled\\:text-button-disabled-foreground-actionbutton) {
    color: hsl(var(--hsl-button-disabled-foreground-actionbutton));
}
#login :is(.group.toaster .group-\\[\\.toaster\\]\\:h-auto) {
    height: auto;
}
#login :is(.group.toaster .group-\\[\\.toaster\\]\\:min-h-11) {
    min-height: 2.75rem;
}
#login :is(.peer:-moz-placeholder ~ .peer-placeholder-shown\\:top-1\\/2) {
    top: 50%;
}
#login :is(.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-1\\/2) {
    top: 50%;
}
#login :is(.peer:-moz-placeholder ~ .peer-placeholder-shown\\:-translate-y-1\\/2) {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login :is(.peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\/2) {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login :is(.peer:-moz-placeholder ~ .peer-placeholder-shown\\:scale-100) {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login :is(.peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100) {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login :is(.peer:focus ~ .peer-focus\\:top-2) {
    top: 0.5rem;
}
#login :is(.peer:focus ~ .peer-focus\\:-translate-y-4) {
    --tw-translate-y: -1rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login :is(.peer:focus ~ .peer-focus\\:scale-75) {
    --tw-scale-x: .75;
    --tw-scale-y: .75;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login :is(.peer:focus ~ .peer-focus\\:px-2) {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
#login :is(.peer:focus ~ .peer-focus\\:text-active-foreground) {
    color: hsl(var(--hsl-active-foreground));
}
#login :is(.peer:disabled ~ .peer-disabled\\:cursor-not-allowed) {
    cursor: not-allowed;
}
#login .aria-disabled\\:pointer-events-none[aria-disabled="true"] {
    pointer-events: none;
}
#login .aria-disabled\\:opacity-60[aria-disabled="true"] {
    opacity: 0.6;
}
#login .aria-selected\\:bg-card-tertiary[aria-selected="true"] {
    background-color: hsl(var(--hsl-card-tertiary));
}
#login .data-\\[state\\=\\"open\\"\\]\\:w-0[data-state="open"] {
    width: 0px;
}
#login .data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
    --tw-translate-y: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
    --tw-translate-x: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
#login .data-\\[loading\\=true\\]\\:animate-pulse[data-loading="true"] {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
#login .data-\\[disabled\\]\\:cursor-not-allowed[data-disabled] {
    cursor: not-allowed;
}
#login .data-\\[loading\\=true\\]\\:border-0[data-loading="true"] {
    border-width: 0px;
}
#login .data-\\[open\\=true\\]\\:border-active-foreground[data-open="true"] {
    border-color: hsl(var(--hsl-active-foreground));
}
#login .data-\\[state\\=error\\]\\:border-error-accent[data-state="error"] {
    border-color: hsl(var(--hsl-error-accent));
}
#login .data-\\[state\\=info\\]\\:border-info-accent[data-state="info"] {
    border-color: hsl(var(--hsl-info-accent));
}
#login .data-\\[state\\=off\\]\\:border-selectable-card-inactive-border[data-state="off"] {
    border-color: hsl(var(--hsl-selectable-card-inactive-default-border));
}
#login .data-\\[state\\=success\\]\\:border-success-accent[data-state="success"] {
    border-color: hsl(var(--hsl-success-accent));
}
#login .data-\\[highlighted\\]\\:bg-active[data-highlighted] {
    background-color: hsl(var(--hsl-active));
}
#login .data-\\[highlighted\\]\\:bg-card-tertiary[data-highlighted] {
    background-color: hsl(var(--hsl-card-tertiary));
}
#login .data-\\[highlighted\\]\\:data-\\[state\\=on\\]\\:bg-active[data-state="on"][data-highlighted] {
    background-color: hsl(var(--hsl-active));
}
#login .data-\\[state\\=on\\]\\:bg-active[data-state="on"] {
    background-color: hsl(var(--hsl-active));
}
#login .data-\\[placeholder\\]\\:text-foreground-secondary[data-placeholder] {
    color: hsl(var(--hsl-foreground-secondary));
}
#login .data-\\[state\\=\\"off\\"\\]\\:text-foreground-secondary[data-state="off"] {
    color: hsl(var(--hsl-foreground-secondary));
}
#login .data-\\[state\\=\\"off\\"\\]\\:line-through[data-state="off"] {
    text-decoration-line: line-through;
}
#login .data-\\[state\\=\\"open\\"\\]\\:opacity-0[data-state="open"] {
    opacity: 0;
}
#login .data-\\[highlighted\\=true\\]\\:ring-1[data-highlighted="true"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[highlighted\\]\\:ring-1[data-highlighted] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[open\\=true\\]\\:ring-1[data-open="true"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=error\\]\\:ring-1[data-state="error"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=info\\]\\:ring-1[data-state="info"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=success\\]\\:ring-1[data-state="success"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[open\\=true\\]\\:ring-active[data-open="true"] {
    --tw-ring-color: hsl(var(--hsl-active));
}
#login .data-\\[state\\=error\\]\\:ring-error-accent[data-state="error"] {
    --tw-ring-color: hsl(var(--hsl-error-accent));
}
#login .data-\\[state\\=info\\]\\:ring-info-accent[data-state="info"] {
    --tw-ring-color: hsl(var(--hsl-info-accent));
}
#login .data-\\[state\\=success\\]\\:ring-success-accent[data-state="success"] {
    --tw-ring-color: hsl(var(--hsl-success-accent));
}
#login .data-\\[state\\=close\\]\\:duration-100[data-state="close"] {
    transition-duration: 100ms;
}
#login .data-\\[state\\=closed\\]\\:duration-100[data-state="closed"] {
    transition-duration: 100ms;
}
#login .data-\\[state\\=open\\]\\:duration-200[data-state="open"] {
    transition-duration: 200ms;
}
#login .data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
    animation-name: enter;
    animation-duration: 150ms;
    --tw-enter-opacity: initial;
    --tw-enter-scale: initial;
    --tw-enter-rotate: initial;
    --tw-enter-translate-x: initial;
    --tw-enter-translate-y: initial;
}
#login .data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
    animation-name: exit;
    animation-duration: 150ms;
    --tw-exit-opacity: initial;
    --tw-exit-scale: initial;
    --tw-exit-rotate: initial;
    --tw-exit-translate-x: initial;
    --tw-exit-translate-y: initial;
}
#login .data-\\[state\\=closed\\]\\:fade-out[data-state="closed"] {
    --tw-exit-opacity: 0;
}
#login .data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
    --tw-exit-opacity: 0;
}
#login .data-\\[state\\=open\\]\\:fade-in[data-state="open"] {
    --tw-enter-opacity: 0;
}
#login .data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
    --tw-enter-opacity: 0;
}
#login .data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
    --tw-exit-scale: .95;
}
#login .data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
    --tw-enter-scale: .95;
}
#login .data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
    --tw-enter-translate-y: -0.5rem;
}
#login .data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
    --tw-enter-translate-x: 0.5rem;
}
#login .data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
    --tw-enter-translate-x: -0.5rem;
}
#login .data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
    --tw-enter-translate-y: 0.5rem;
}
#login .data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
    --tw-exit-translate-x: -100%;
}
#login .data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
    --tw-exit-translate-x: -50%;
}
#login .data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
    --tw-exit-translate-x: 100%;
}
#login .data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
    --tw-exit-translate-y: -48%;
}
#login .data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
    --tw-enter-translate-x: -100%;
}
#login .data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
    --tw-enter-translate-x: -50%;
}
#login .data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
    --tw-enter-translate-x: 100%;
}
#login .data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
    --tw-enter-translate-y: -48%;
}
#login .data-\\[state\\=close\\]\\:duration-100[data-state="close"] {
    animation-duration: 100ms;
}
#login .data-\\[state\\=closed\\]\\:duration-100[data-state="closed"] {
    animation-duration: 100ms;
}
#login .data-\\[state\\=open\\]\\:duration-200[data-state="open"] {
    animation-duration: 200ms;
}
#login .data-\\[state\\=active\\]\\:after\\:bg-button-primary[data-state="active"]::after {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-primary));
}
#login :is(.group\\/button[data-loading="true"] .group-data-\\[loading\\=true\\]\\/button\\:sr-only) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
#login :is(.group\\/button[data-variant="soft"][data-loading="true"] .group-data-\\[variant\\=soft\\]\\/button\\:group-data-\\[loading\\=true\\]\\/button\\:not-sr-only) {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
}
#login :is(.group\\/button[data-variant="solid"][data-loading="true"] .group-data-\\[variant\\=solid\\]\\/button\\:group-data-\\[loading\\=true\\]\\/button\\:not-sr-only) {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
}
#login :is(.group\\/button[data-variant="soft"][data-loading="true"] .group-data-\\[variant\\=soft\\]\\/button\\:group-data-\\[loading\\=true\\]\\/button\\:block) {
    display: block;
}
#login :is(.group\\/button[data-variant="solid"][data-loading="true"] .group-data-\\[variant\\=solid\\]\\/button\\:group-data-\\[loading\\=true\\]\\/button\\:block) {
    display: block;
}
#login :is(.group\\/checkbox-indicator[data-state="checked"] .group-data-\\[state\\=checked\\]\\/checkbox-indicator\\:flex) {
    display: flex;
}
#login :is(.group\\/checkbox-indicator[data-state="indeterminate"] .group-data-\\[state\\=indeterminate\\]\\/checkbox-indicator\\:flex) {
    display: flex;
}
#login :is(.group[data-state="on"] .group-data-\\[state\\=on\\]\\:flex) {
    display: flex;
}
#login :is(.group\\/checkbox-indicator[data-state="unchecked"] .group-data-\\[state\\=unchecked\\]\\/checkbox-indicator\\:flex) {
    display: flex;
}
#login :is(.group\\/button[data-loading="false"] .group-data-\\[loading\\=false\\]\\/button\\:hidden) {
    display: none;
}
#login :is(.group\\/button[data-loading="true"] .group-data-\\[loading\\=true\\]\\/button\\:hidden) {
    display: none;
}
#login :is(.group\\/radio-item[data-state="checked"] .group-data-\\[state\\=checked\\]\\/radio-item\\:hidden) {
    display: none;
}
#login :is(.group[data-state="on"] .group-data-\\[state\\=on\\]\\:hidden) {
    display: none;
}
#login :is(.group\\/radio-item[data-state="unchecked"] .group-data-\\[state\\=unchecked\\]\\/radio-item\\:hidden) {
    display: none;
}
#login :is(.group\\/button[data-variant="soft"] .group-data-\\[variant\\=soft\\]\\/button\\:hidden) {
    display: none;
}
#login :is(.group\\/button[data-variant="solid"] .group-data-\\[variant\\=solid\\]\\/button\\:hidden) {
    display: none;
}
#login :is(.group\\/radio-item[data-disabled] .group-data-\\[disabled\\]\\/radio-item\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.group\\/radio-item[data-readonly='false'][data-disabled] .group-data-\\[readonly\\=\\'false\\'\\]\\/radio-item\\:group-data-\\[disabled\\]\\/radio-item\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.group\\/selectable-card[data-state="active"] .group-data-\\[state\\=active\\]\\/selectable-card\\:text-active-foreground) {
    color: hsl(var(--hsl-active-foreground));
}
#login :is(.group\\/selectable-card[data-state="on"] .group-data-\\[state\\=on\\]\\/selectable-card\\:text-active-foreground) {
    color: hsl(var(--hsl-active-foreground));
}
#login :is(.group\\/button[data-variant="ghost"] .group-data-\\[variant\\=ghost\\]\\/button\\:text-sidebar-foreground-secondary) {
    color: hsl(var(--hsl-sidebar-foreground-secondary));
}
#login :is(.group\\/button[data-variant="soft"][data-loading="true"] .group-data-\\[variant\\=soft\\]\\/button\\:group-data-\\[loading\\=true\\]\\/button\\:opacity-0) {
    opacity: 0;
}
#login :is(.group\\/button[data-variant="solid"][data-loading="true"] .group-data-\\[variant\\=solid\\]\\/button\\:group-data-\\[loading\\=true\\]\\/button\\:opacity-0) {
    opacity: 0;
}
#login :is(.group\\/button[data-colour="blue"] .group-data-\\[colour\\=blue\\]\\/button\\:before\\:bg-button-blue-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-blue-skeleton));
}
#login :is(.group\\/button[data-colour="cyan"] .group-data-\\[colour\\=cyan\\]\\/button\\:before\\:bg-button-cyan-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-cyan-skeleton));
}
#login :is(.group\\/button[data-colour="green"] .group-data-\\[colour\\=green\\]\\/button\\:before\\:bg-button-green-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-green-skeleton));
}
#login :is(.group\\/button[data-colour="inverse"] .group-data-\\[colour\\=inverse\\]\\/button\\:before\\:bg-button-inverse-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-inverse-skeleton));
}
#login :is(.group\\/button[data-colour="neutral"] .group-data-\\[colour\\=neutral\\]\\/button\\:before\\:bg-button-neutral-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-neutral-skeleton));
}
#login :is(.group\\/button[data-colour="primary"] .group-data-\\[colour\\=primary\\]\\/button\\:before\\:bg-button-primary-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-primary-skeleton));
}
#login :is(.group\\/button[data-colour="purple"] .group-data-\\[colour\\=purple\\]\\/button\\:before\\:bg-button-purple-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-purple-skeleton));
}
#login :is(.group\\/button[data-colour="red"] .group-data-\\[colour\\=red\\]\\/button\\:before\\:bg-button-red-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-red-skeleton));
}
#login :is(.group\\/button[data-colour="yellow"] .group-data-\\[colour\\=yellow\\]\\/button\\:before\\:bg-button-yellow-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-button-yellow-skeleton));
}
#login :is(.group\\/button[data-variant="ghost"] .group-data-\\[variant\\=ghost\\]\\/button\\:before\\:bg-sidebar-skeleton)::before {
    content: var(--tw-content);
    background-color: hsl(var(--hsl-sidebar-skeleton));
}
#login :is(.group\\/radio-root[data-disabled='false']:hover .group-data-\\[disabled\\=\\'false\\'\\]\\/radio-root\\:group-hover\\/radio-root\\:text-inactive-foreground) {
    color: hsl(var(--hsl-inactive-foreground));
}
#login :is(.group\\/selectable-card[data-state="on"]:disabled .group-data-\\[state\\=on\\]\\/selectable-card\\:group-disabled\\/selectable-card\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.group\\/checkbox-indicator:disabled[data-readonly='false'] .group-disabled\\/checkbox-indicator\\:group-data-\\[readonly\\=\\'false\\'\\]\\/checkbox-indicator\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.group\\/checkbox-root:hover .group\\/checkbox-indicator:disabled[data-readonly='false'] .group-hover\\/checkbox-root\\:group-disabled\\/checkbox-indicator\\:group-data-\\[readonly\\=\\'false\\'\\]\\/checkbox-indicator\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login :is(.peer:disabled[data-readonly='false'] ~ .peer-disabled\\:peer-data-\\[readonly\\=\\'false\\'\\]\\:text-inactive-readonly) {
    color: hsl(var(--hsl-inactive-readonly));
}
#login .hover\\:z-10:hover {
    z-index: 10;
}
#login .hover\\:cursor-pointer:hover {
    cursor: pointer;
}
#login .hover\\:border-active-foreground:hover {
    border-color: hsl(var(--hsl-active-foreground));
}
#login .hover\\:border-button-blue-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-blue-outline-hover-border));
}
#login .hover\\:border-button-blue-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-blue-surface-hover-border));
}
#login .hover\\:border-button-cyan-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-cyan-outline-hover-border));
}
#login .hover\\:border-button-cyan-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-cyan-surface-hover-border));
}
#login .hover\\:border-button-green-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-green-outline-hover-border));
}
#login .hover\\:border-button-green-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-green-surface-hover-border));
}
#login .hover\\:border-button-inverse-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-inverse-outline-hover-border));
}
#login .hover\\:border-button-inverse-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-inverse-surface-hover-border));
}
#login .hover\\:border-button-neutral-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-neutral-outline-hover-border));
}
#login .hover\\:border-button-neutral-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-neutral-surface-hover-border));
}
#login .hover\\:border-button-primary-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-primary-outline-hover-border));
}
#login .hover\\:border-button-primary-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-primary-surface-hover-border));
}
#login .hover\\:border-button-purple-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-purple-outline-hover-border));
}
#login .hover\\:border-button-purple-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-purple-surface-hover-border));
}
#login .hover\\:border-button-red-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-red-outline-hover-border));
}
#login .hover\\:border-button-red-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-red-surface-hover-border));
}
#login .hover\\:border-button-yellow-outline-hover-border:hover {
    border-color: hsl(var(--hsl-button-yellow-outline-hover-border));
}
#login .hover\\:border-button-yellow-surface-hover-border:hover {
    border-color: hsl(var(--hsl-button-yellow-surface-hover-border));
}
#login .hover\\:bg-button-blue-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-blue-ghost-hover-background));
}
#login .hover\\:bg-button-blue-outline-hover:hover {
    background-color: hsl(var(--hsl-button-blue-outline-hover-background));
}
#login .hover\\:bg-button-blue-soft-hover:hover {
    background-color: hsl(var(--hsl-button-blue-soft-hover-background));
}
#login .hover\\:bg-button-blue-solid-hover:hover {
    background-color: hsl(var(--hsl-button-blue-solid-hover-background));
}
#login .hover\\:bg-button-blue-surface-hover:hover {
    background-color: hsl(var(--hsl-button-blue-surface-hover-background));
}
#login .hover\\:bg-button-cyan-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-cyan-ghost-hover-background));
}
#login .hover\\:bg-button-cyan-outline-hover:hover {
    background-color: hsl(var(--hsl-button-cyan-outline-hover-background));
}
#login .hover\\:bg-button-cyan-soft-hover:hover {
    background-color: hsl(var(--hsl-button-cyan-soft-hover-background));
}
#login .hover\\:bg-button-cyan-solid-hover:hover {
    background-color: hsl(var(--hsl-button-cyan-solid-hover-background));
}
#login .hover\\:bg-button-cyan-surface-hover:hover {
    background-color: hsl(var(--hsl-button-cyan-surface-hover-background));
}
#login .hover\\:bg-button-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-ghost-hover));
}
#login .hover\\:bg-button-green-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-green-ghost-hover-background));
}
#login .hover\\:bg-button-green-outline-hover:hover {
    background-color: hsl(var(--hsl-button-green-outline-hover-background));
}
#login .hover\\:bg-button-green-soft-hover:hover {
    background-color: hsl(var(--hsl-button-green-soft-hover-background));
}
#login .hover\\:bg-button-green-solid-hover:hover {
    background-color: hsl(var(--hsl-button-green-solid-hover-background));
}
#login .hover\\:bg-button-green-surface-hover:hover {
    background-color: hsl(var(--hsl-button-green-surface-hover-background));
}
#login .hover\\:bg-button-inverse-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-inverse-ghost-hover-background));
}
#login .hover\\:bg-button-inverse-outline-hover:hover {
    background-color: hsl(var(--hsl-button-inverse-outline-hover-background));
}
#login .hover\\:bg-button-inverse-soft-hover:hover {
    background-color: hsl(var(--hsl-button-inverse-soft-hover-background));
}
#login .hover\\:bg-button-inverse-solid-hover:hover {
    background-color: hsl(var(--hsl-button-inverse-solid-hover-background));
}
#login .hover\\:bg-button-inverse-surface-hover:hover {
    background-color: hsl(var(--hsl-button-inverse-surface-hover-background));
}
#login .hover\\:bg-button-neutral-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-neutral-ghost-hover-background));
}
#login .hover\\:bg-button-neutral-outline-hover:hover {
    background-color: hsl(var(--hsl-button-neutral-outline-hover-background));
}
#login .hover\\:bg-button-neutral-soft-hover:hover {
    background-color: hsl(var(--hsl-button-neutral-soft-hover-background));
}
#login .hover\\:bg-button-neutral-solid-hover:hover {
    background-color: hsl(var(--hsl-button-neutral-solid-hover-background));
}
#login .hover\\:bg-button-neutral-surface-hover:hover {
    background-color: hsl(var(--hsl-button-neutral-surface-hover-background));
}
#login .hover\\:bg-button-primary-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-primary-ghost-hover-background));
}
#login .hover\\:bg-button-primary-outline-hover:hover {
    background-color: hsl(var(--hsl-button-primary-outline-hover-background));
}
#login .hover\\:bg-button-primary-soft-hover:hover {
    background-color: hsl(var(--hsl-button-primary-soft-hover-background));
}
#login .hover\\:bg-button-primary-solid-hover:hover {
    background-color: hsl(var(--hsl-button-primary-solid-hover-background));
}
#login .hover\\:bg-button-primary-surface-hover:hover {
    background-color: hsl(var(--hsl-button-primary-surface-hover-background));
}
#login .hover\\:bg-button-purple-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-purple-ghost-hover-background));
}
#login .hover\\:bg-button-purple-outline-hover:hover {
    background-color: hsl(var(--hsl-button-purple-outline-hover-background));
}
#login .hover\\:bg-button-purple-soft-hover:hover {
    background-color: hsl(var(--hsl-button-purple-soft-hover-background));
}
#login .hover\\:bg-button-purple-solid-hover:hover {
    background-color: hsl(var(--hsl-button-purple-solid-hover-background));
}
#login .hover\\:bg-button-purple-surface-hover:hover {
    background-color: hsl(var(--hsl-button-purple-surface-hover-background));
}
#login .hover\\:bg-button-red-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-red-ghost-hover-background));
}
#login .hover\\:bg-button-red-outline-hover:hover {
    background-color: hsl(var(--hsl-button-red-outline-hover-background));
}
#login .hover\\:bg-button-red-soft-hover:hover {
    background-color: hsl(var(--hsl-button-red-soft-hover-background));
}
#login .hover\\:bg-button-red-solid-hover:hover {
    background-color: hsl(var(--hsl-button-red-solid-hover-background));
}
#login .hover\\:bg-button-red-surface-hover:hover {
    background-color: hsl(var(--hsl-button-red-surface-hover-background));
}
#login .hover\\:bg-button-yellow-ghost-hover:hover {
    background-color: hsl(var(--hsl-button-yellow-ghost-hover-background));
}
#login .hover\\:bg-button-yellow-outline-hover:hover {
    background-color: hsl(var(--hsl-button-yellow-outline-hover-background));
}
#login .hover\\:bg-button-yellow-soft-hover:hover {
    background-color: hsl(var(--hsl-button-yellow-soft-hover-background));
}
#login .hover\\:bg-button-yellow-solid-hover:hover {
    background-color: hsl(var(--hsl-button-yellow-solid-hover-background));
}
#login .hover\\:bg-button-yellow-surface-hover:hover {
    background-color: hsl(var(--hsl-button-yellow-surface-hover-background));
}
#login .hover\\:bg-sidebar-hover:hover {
    background-color: hsl(var(--hsl-sidebar-hover));
}
#login .hover\\:bg-switch-off-hover:hover {
    background-color: hsl(var(--hsl-switch-off-hover));
}
#login .hover\\:text-button-blue-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-blue-ghost-hover-foreground));
}
#login .hover\\:text-button-blue-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-blue-outline-hover-foreground));
}
#login .hover\\:text-button-blue-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-blue-soft-hover-foreground));
}
#login .hover\\:text-button-blue-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-blue-solid-hover-foreground));
}
#login .hover\\:text-button-blue-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-blue-surface-hover-foreground));
}
#login .hover\\:text-button-cyan-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-cyan-ghost-hover-foreground));
}
#login .hover\\:text-button-cyan-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-cyan-outline-hover-foreground));
}
#login .hover\\:text-button-cyan-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-cyan-soft-hover-foreground));
}
#login .hover\\:text-button-cyan-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-cyan-solid-hover-foreground));
}
#login .hover\\:text-button-cyan-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-cyan-surface-hover-foreground));
}
#login .hover\\:text-button-green-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-green-ghost-hover-foreground));
}
#login .hover\\:text-button-green-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-green-outline-hover-foreground));
}
#login .hover\\:text-button-green-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-green-soft-hover-foreground));
}
#login .hover\\:text-button-green-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-green-solid-hover-foreground));
}
#login .hover\\:text-button-green-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-green-surface-hover-foreground));
}
#login .hover\\:text-button-inverse-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-inverse-ghost-hover-foreground));
}
#login .hover\\:text-button-inverse-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-inverse-outline-hover-foreground));
}
#login .hover\\:text-button-inverse-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-inverse-soft-hover-foreground));
}
#login .hover\\:text-button-inverse-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-inverse-solid-hover-foreground));
}
#login .hover\\:text-button-inverse-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-inverse-surface-hover-foreground));
}
#login .hover\\:text-button-neutral-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-neutral-ghost-hover-foreground));
}
#login .hover\\:text-button-neutral-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-neutral-outline-hover-foreground));
}
#login .hover\\:text-button-neutral-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-neutral-soft-hover-foreground));
}
#login .hover\\:text-button-neutral-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-neutral-solid-hover-foreground));
}
#login .hover\\:text-button-neutral-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-neutral-surface-hover-foreground));
}
#login .hover\\:text-button-primary-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-primary-ghost-hover-foreground));
}
#login .hover\\:text-button-primary-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-primary-outline-hover-foreground));
}
#login .hover\\:text-button-primary-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-primary-soft-hover-foreground));
}
#login .hover\\:text-button-primary-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-primary-solid-hover-foreground));
}
#login .hover\\:text-button-primary-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-primary-surface-hover-foreground));
}
#login .hover\\:text-button-purple-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-purple-ghost-hover-foreground));
}
#login .hover\\:text-button-purple-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-purple-outline-hover-foreground));
}
#login .hover\\:text-button-purple-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-purple-soft-hover-foreground));
}
#login .hover\\:text-button-purple-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-purple-solid-hover-foreground));
}
#login .hover\\:text-button-purple-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-purple-surface-hover-foreground));
}
#login .hover\\:text-button-red-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-red-ghost-hover-foreground));
}
#login .hover\\:text-button-red-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-red-outline-hover-foreground));
}
#login .hover\\:text-button-red-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-red-soft-hover-foreground));
}
#login .hover\\:text-button-red-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-red-solid-hover-foreground));
}
#login .hover\\:text-button-red-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-red-surface-hover-foreground));
}
#login .hover\\:text-button-yellow-ghost-hover-foreground:hover {
    color: hsl(var(--hsl-button-yellow-ghost-hover-foreground));
}
#login .hover\\:text-button-yellow-outline-hover-foreground:hover {
    color: hsl(var(--hsl-button-yellow-outline-hover-foreground));
}
#login .hover\\:text-button-yellow-soft-hover-foreground:hover {
    color: hsl(var(--hsl-button-yellow-soft-hover-foreground));
}
#login .hover\\:text-button-yellow-solid-hover-foreground:hover {
    color: hsl(var(--hsl-button-yellow-solid-hover-foreground));
}
#login .hover\\:text-button-yellow-surface-hover-foreground:hover {
    color: hsl(var(--hsl-button-yellow-surface-hover-foreground));
}
#login .hover\\:text-foreground:hover {
    color: hsl(var(--hsl-foreground));
}
#login .hover\\:text-sidebar-foreground:hover {
    color: hsl(var(--hsl-sidebar-foreground));
}
#login .hover\\:text-textlink-hover:hover {
    color: hsl(var(--hsl-textlink-hover));
}
#login .hover\\:underline:hover {
    text-decoration-line: underline;
}
#login .hover\\:no-underline:hover {
    text-decoration-line: none;
}
#login .hover\\:decoration-foreground:hover {
    text-decoration-color: hsl(var(--hsl-foreground));
}
#login .hover\\:ring-1:hover {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .hover\\:ring-border-tertiary:hover {
    --tw-ring-color: hsl(var(--hsl-border-tertiary));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-blue-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-blue-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-cyan-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-cyan-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-green-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-green-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-inverse-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-inverse-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-neutral-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-neutral-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-primary-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-primary-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-purple-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-purple-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-red-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-red-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:border-button-yellow-surface-border:hover[data-state="on"] {
    border-color: hsl(var(--hsl-button-yellow-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-blue-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-blue-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-cyan-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-cyan-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-green-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-green-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-inverse-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-inverse-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-neutral-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-neutral-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-primary-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-primary-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-purple-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-purple-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-red-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-red-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:hover\\:bg-button-yellow-surface:hover[data-state="on"] {
    background-color: hsl(var(--hsl-button-yellow-surface-default-background));
}
#login .hover\\:data-\\[state\\=off\\]\\:bg-card-tertiary[data-state="off"]:hover {
    background-color: hsl(var(--hsl-card-tertiary));
}
#login .data-\\[state\\=error\\]\\:hover\\:ring-border-tertiary:hover[data-state="error"] {
    --tw-ring-color: hsl(var(--hsl-border-tertiary));
}
#login .data-\\[state\\=info\\]\\:hover\\:ring-border-tertiary:hover[data-state="info"] {
    --tw-ring-color: hsl(var(--hsl-border-tertiary));
}
#login .data-\\[state\\=success\\]\\:hover\\:ring-border-tertiary:hover[data-state="success"] {
    --tw-ring-color: hsl(var(--hsl-border-tertiary));
}
#login :is(.group\\/button[data-variant="ghost"] .group-data-\\[variant\\=ghost\\]\\/button\\:hover\\:text-sidebar-foreground:hover) {
    color: hsl(var(--hsl-sidebar-foreground));
}
#login .focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
#login .focus\\:outline-offset-2:focus {
    outline-offset: 2px;
}
#login .focus\\:outline-focus:focus {
    outline-color: hsl(var(--hsl-focus));
}
#login .focus\\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login :is(.group\\/input:hover .focus\\:group-hover\\/input\\:ring-2:focus) {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=error\\]\\:focus\\:ring-2:focus[data-state="error"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=info\\]\\:focus\\:ring-2:focus[data-state="info"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=success\\]\\:focus\\:ring-2:focus[data-state="success"] {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .focus-visible\\:z-10:focus-visible {
    z-index: 10;
}
#login .focus-visible\\:border-0:focus-visible {
    border-width: 0px;
}
#login .focus-visible\\:border-y:focus-visible {
    border-top-width: 1px;
    border-bottom-width: 1px;
}
#login .focus-visible\\:border-active-foreground:focus-visible {
    border-color: hsl(var(--hsl-active-foreground));
}
#login .focus-visible\\:border-focus:focus-visible {
    border-color: hsl(var(--hsl-focus));
}
#login .focus-visible\\:stroke-card:focus-visible {
    stroke: hsl(var(--hsl-card));
}
#login .focus-visible\\:outline-none:focus-visible {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
#login .focus-visible\\:outline:focus-visible {
    outline-style: solid;
}
#login .focus-visible\\:outline-focus:focus-visible {
    outline-color: hsl(var(--hsl-focus));
}
#login .focus-visible\\:ring-1:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .focus-visible\\:ring-2:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .focus-visible\\:ring-inset:focus-visible {
    --tw-ring-inset: inset;
}
#login .focus-visible\\:ring-active:focus-visible {
    --tw-ring-color: hsl(var(--hsl-active));
}
#login .focus-visible\\:ring-focus:focus-visible {
    --tw-ring-color: hsl(var(--hsl-focus));
}
#login :is(.group\\/input:hover .focus-visible\\:group-hover\\/input\\:ring-active:focus-visible) {
    --tw-ring-color: hsl(var(--hsl-active));
}
#login .active\\:z-10:active {
    z-index: 10;
}
#login .active\\:border-active-foreground:active {
    border-color: hsl(var(--hsl-active-foreground));
}
#login .active\\:border-button-blue-outline-press-border:active {
    border-color: hsl(var(--hsl-button-blue-outline-press-border));
}
#login .active\\:border-button-blue-surface-press-border:active {
    border-color: hsl(var(--hsl-button-blue-surface-press-border));
}
#login .active\\:border-button-cyan-outline-press-border:active {
    border-color: hsl(var(--hsl-button-cyan-outline-press-border));
}
#login .active\\:border-button-cyan-surface-press-border:active {
    border-color: hsl(var(--hsl-button-cyan-surface-press-border));
}
#login .active\\:border-button-green-outline-press-border:active {
    border-color: hsl(var(--hsl-button-green-outline-press-border));
}
#login .active\\:border-button-green-surface-press-border:active {
    border-color: hsl(var(--hsl-button-green-surface-press-border));
}
#login .active\\:border-button-inverse-outline-press-border:active {
    border-color: hsl(var(--hsl-button-inverse-outline-press-border));
}
#login .active\\:border-button-inverse-surface-press-border:active {
    border-color: hsl(var(--hsl-button-inverse-surface-press-border));
}
#login .active\\:border-button-neutral-outline-press-border:active {
    border-color: hsl(var(--hsl-button-neutral-outline-press-border));
}
#login .active\\:border-button-neutral-surface-press-border:active {
    border-color: hsl(var(--hsl-button-neutral-surface-press-border));
}
#login .active\\:border-button-primary-outline-press-border:active {
    border-color: hsl(var(--hsl-button-primary-outline-press-border));
}
#login .active\\:border-button-primary-surface-press-border:active {
    border-color: hsl(var(--hsl-button-primary-surface-press-border));
}
#login .active\\:border-button-purple-outline-press-border:active {
    border-color: hsl(var(--hsl-button-purple-outline-press-border));
}
#login .active\\:border-button-purple-surface-press-border:active {
    border-color: hsl(var(--hsl-button-purple-surface-press-border));
}
#login .active\\:border-button-red-outline-press-border:active {
    border-color: hsl(var(--hsl-button-red-outline-press-border));
}
#login .active\\:border-button-red-surface-press-border:active {
    border-color: hsl(var(--hsl-button-red-surface-press-border));
}
#login .active\\:border-button-yellow-outline-press-border:active {
    border-color: hsl(var(--hsl-button-yellow-outline-press-border));
}
#login .active\\:border-button-yellow-surface-press-border:active {
    border-color: hsl(var(--hsl-button-yellow-surface-press-border));
}
#login .active\\:bg-button-blue-ghost-press:active {
    background-color: hsl(var(--hsl-button-blue-ghost-press-background));
}
#login .active\\:bg-button-blue-outline-press:active {
    background-color: hsl(var(--hsl-button-blue-outline-press-background));
}
#login .active\\:bg-button-blue-soft-press:active {
    background-color: hsl(var(--hsl-button-blue-soft-press-background));
}
#login .active\\:bg-button-blue-solid-press:active {
    background-color: hsl(var(--hsl-button-blue-solid-press-background));
}
#login .active\\:bg-button-blue-surface-press:active {
    background-color: hsl(var(--hsl-button-blue-surface-press-background));
}
#login .active\\:bg-button-cyan-ghost-press:active {
    background-color: hsl(var(--hsl-button-cyan-ghost-press-background));
}
#login .active\\:bg-button-cyan-outline-press:active {
    background-color: hsl(var(--hsl-button-cyan-outline-press-background));
}
#login .active\\:bg-button-cyan-soft-press:active {
    background-color: hsl(var(--hsl-button-cyan-soft-press-background));
}
#login .active\\:bg-button-cyan-solid-press:active {
    background-color: hsl(var(--hsl-button-cyan-solid-press-background));
}
#login .active\\:bg-button-cyan-surface-press:active {
    background-color: hsl(var(--hsl-button-cyan-surface-press-background));
}
#login .active\\:bg-button-ghost-press:active {
    background-color: hsl(var(--hsl-button-ghost-press));
}
#login .active\\:bg-button-green-ghost-press:active {
    background-color: hsl(var(--hsl-button-green-ghost-press-background));
}
#login .active\\:bg-button-green-outline-press:active {
    background-color: hsl(var(--hsl-button-green-outline-press-background));
}
#login .active\\:bg-button-green-soft-press:active {
    background-color: hsl(var(--hsl-button-green-soft-press-background));
}
#login .active\\:bg-button-green-solid-press:active {
    background-color: hsl(var(--hsl-button-green-solid-press-background));
}
#login .active\\:bg-button-green-surface-press:active {
    background-color: hsl(var(--hsl-button-green-surface-press-background));
}
#login .active\\:bg-button-inverse-ghost-press:active {
    background-color: hsl(var(--hsl-button-inverse-ghost-press-background));
}
#login .active\\:bg-button-inverse-outline-press:active {
    background-color: hsl(var(--hsl-button-inverse-outline-press-background));
}
#login .active\\:bg-button-inverse-soft-press:active {
    background-color: hsl(var(--hsl-button-inverse-soft-press-background));
}
#login .active\\:bg-button-inverse-solid-press:active {
    background-color: hsl(var(--hsl-button-inverse-solid-press-background));
}
#login .active\\:bg-button-inverse-surface-press:active {
    background-color: hsl(var(--hsl-button-inverse-surface-press-background));
}
#login .active\\:bg-button-neutral-ghost-press:active {
    background-color: hsl(var(--hsl-button-neutral-ghost-press-background));
}
#login .active\\:bg-button-neutral-outline-press:active {
    background-color: hsl(var(--hsl-button-neutral-outline-press-background));
}
#login .active\\:bg-button-neutral-soft-press:active {
    background-color: hsl(var(--hsl-button-neutral-soft-press-background));
}
#login .active\\:bg-button-neutral-solid-press:active {
    background-color: hsl(var(--hsl-button-neutral-solid-press-background));
}
#login .active\\:bg-button-neutral-surface-press:active {
    background-color: hsl(var(--hsl-button-neutral-surface-press-background));
}
#login .active\\:bg-button-primary-ghost-press:active {
    background-color: hsl(var(--hsl-button-primary-ghost-press-background));
}
#login .active\\:bg-button-primary-outline-press:active {
    background-color: hsl(var(--hsl-button-primary-outline-press-background));
}
#login .active\\:bg-button-primary-soft-press:active {
    background-color: hsl(var(--hsl-button-primary-soft-press-background));
}
#login .active\\:bg-button-primary-solid-press:active {
    background-color: hsl(var(--hsl-button-primary-solid-press-background));
}
#login .active\\:bg-button-primary-surface-press:active {
    background-color: hsl(var(--hsl-button-primary-surface-press-background));
}
#login .active\\:bg-button-purple-ghost-press:active {
    background-color: hsl(var(--hsl-button-purple-ghost-press-background));
}
#login .active\\:bg-button-purple-outline-press:active {
    background-color: hsl(var(--hsl-button-purple-outline-press-background));
}
#login .active\\:bg-button-purple-soft-press:active {
    background-color: hsl(var(--hsl-button-purple-soft-press-background));
}
#login .active\\:bg-button-purple-solid-press:active {
    background-color: hsl(var(--hsl-button-purple-solid-press-background));
}
#login .active\\:bg-button-purple-surface-press:active {
    background-color: hsl(var(--hsl-button-purple-surface-press-background));
}
#login .active\\:bg-button-red-ghost-press:active {
    background-color: hsl(var(--hsl-button-red-ghost-press-background));
}
#login .active\\:bg-button-red-outline-press:active {
    background-color: hsl(var(--hsl-button-red-outline-press-background));
}
#login .active\\:bg-button-red-soft-press:active {
    background-color: hsl(var(--hsl-button-red-soft-press-background));
}
#login .active\\:bg-button-red-solid-press:active {
    background-color: hsl(var(--hsl-button-red-solid-press-background));
}
#login .active\\:bg-button-red-surface-press:active {
    background-color: hsl(var(--hsl-button-red-surface-press-background));
}
#login .active\\:bg-button-yellow-ghost-press:active {
    background-color: hsl(var(--hsl-button-yellow-ghost-press-background));
}
#login .active\\:bg-button-yellow-outline-press:active {
    background-color: hsl(var(--hsl-button-yellow-outline-press-background));
}
#login .active\\:bg-button-yellow-soft-press:active {
    background-color: hsl(var(--hsl-button-yellow-soft-press-background));
}
#login .active\\:bg-button-yellow-solid-press:active {
    background-color: hsl(var(--hsl-button-yellow-solid-press-background));
}
#login .active\\:bg-button-yellow-surface-press:active {
    background-color: hsl(var(--hsl-button-yellow-surface-press-background));
}
#login .active\\:bg-sidebar-hover:active {
    background-color: hsl(var(--hsl-sidebar-hover));
}
#login .active\\:text-button-blue-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-blue-ghost-press-foreground));
}
#login .active\\:text-button-blue-outline-press-foreground:active {
    color: hsl(var(--hsl-button-blue-outline-press-foreground));
}
#login .active\\:text-button-blue-soft-press-foreground:active {
    color: hsl(var(--hsl-button-blue-soft-press-foreground));
}
#login .active\\:text-button-blue-solid-press-foreground:active {
    color: hsl(var(--hsl-button-blue-solid-press-foreground));
}
#login .active\\:text-button-blue-surface-press-foreground:active {
    color: hsl(var(--hsl-button-blue-surface-press-foreground));
}
#login .active\\:text-button-cyan-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-cyan-ghost-press-foreground));
}
#login .active\\:text-button-cyan-outline-press-foreground:active {
    color: hsl(var(--hsl-button-cyan-outline-press-foreground));
}
#login .active\\:text-button-cyan-soft-press-foreground:active {
    color: hsl(var(--hsl-button-cyan-soft-press-foreground));
}
#login .active\\:text-button-cyan-solid-press-foreground:active {
    color: hsl(var(--hsl-button-cyan-solid-press-foreground));
}
#login .active\\:text-button-cyan-surface-press-foreground:active {
    color: hsl(var(--hsl-button-cyan-surface-press-foreground));
}
#login .active\\:text-button-green-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-green-ghost-press-foreground));
}
#login .active\\:text-button-green-outline-press-foreground:active {
    color: hsl(var(--hsl-button-green-outline-press-foreground));
}
#login .active\\:text-button-green-soft-press-foreground:active {
    color: hsl(var(--hsl-button-green-soft-press-foreground));
}
#login .active\\:text-button-green-solid-press-foreground:active {
    color: hsl(var(--hsl-button-green-solid-press-foreground));
}
#login .active\\:text-button-green-surface-press-foreground:active {
    color: hsl(var(--hsl-button-green-surface-press-foreground));
}
#login .active\\:text-button-inverse-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-inverse-ghost-press-foreground));
}
#login .active\\:text-button-inverse-outline-press-foreground:active {
    color: hsl(var(--hsl-button-inverse-outline-press-foreground));
}
#login .active\\:text-button-inverse-soft-press-foreground:active {
    color: hsl(var(--hsl-button-inverse-soft-press-foreground));
}
#login .active\\:text-button-inverse-solid-press-foreground:active {
    color: hsl(var(--hsl-button-inverse-solid-press-foreground));
}
#login .active\\:text-button-inverse-surface-press-foreground:active {
    color: hsl(var(--hsl-button-inverse-surface-press-foreground));
}
#login .active\\:text-button-neutral-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-neutral-ghost-press-foreground));
}
#login .active\\:text-button-neutral-outline-press-foreground:active {
    color: hsl(var(--hsl-button-neutral-outline-press-foreground));
}
#login .active\\:text-button-neutral-soft-press-foreground:active {
    color: hsl(var(--hsl-button-neutral-soft-press-foreground));
}
#login .active\\:text-button-neutral-solid-press-foreground:active {
    color: hsl(var(--hsl-button-neutral-solid-press-foreground));
}
#login .active\\:text-button-neutral-surface-press-foreground:active {
    color: hsl(var(--hsl-button-neutral-surface-press-foreground));
}
#login .active\\:text-button-primary-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-primary-ghost-press-foreground));
}
#login .active\\:text-button-primary-outline-press-foreground:active {
    color: hsl(var(--hsl-button-primary-outline-press-foreground));
}
#login .active\\:text-button-primary-soft-press-foreground:active {
    color: hsl(var(--hsl-button-primary-soft-press-foreground));
}
#login .active\\:text-button-primary-solid-press-foreground:active {
    color: hsl(var(--hsl-button-primary-solid-press-foreground));
}
#login .active\\:text-button-primary-surface-press-foreground:active {
    color: hsl(var(--hsl-button-primary-surface-press-foreground));
}
#login .active\\:text-button-purple-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-purple-ghost-press-foreground));
}
#login .active\\:text-button-purple-outline-press-foreground:active {
    color: hsl(var(--hsl-button-purple-outline-press-foreground));
}
#login .active\\:text-button-purple-soft-press-foreground:active {
    color: hsl(var(--hsl-button-purple-soft-press-foreground));
}
#login .active\\:text-button-purple-solid-press-foreground:active {
    color: hsl(var(--hsl-button-purple-solid-press-foreground));
}
#login .active\\:text-button-purple-surface-press-foreground:active {
    color: hsl(var(--hsl-button-purple-surface-press-foreground));
}
#login .active\\:text-button-red-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-red-ghost-press-foreground));
}
#login .active\\:text-button-red-outline-press-foreground:active {
    color: hsl(var(--hsl-button-red-outline-press-foreground));
}
#login .active\\:text-button-red-soft-press-foreground:active {
    color: hsl(var(--hsl-button-red-soft-press-foreground));
}
#login .active\\:text-button-red-solid-press-foreground:active {
    color: hsl(var(--hsl-button-red-solid-press-foreground));
}
#login .active\\:text-button-red-surface-press-foreground:active {
    color: hsl(var(--hsl-button-red-surface-press-foreground));
}
#login .active\\:text-button-yellow-ghost-press-foreground:active {
    color: hsl(var(--hsl-button-yellow-ghost-press-foreground));
}
#login .active\\:text-button-yellow-outline-press-foreground:active {
    color: hsl(var(--hsl-button-yellow-outline-press-foreground));
}
#login .active\\:text-button-yellow-soft-press-foreground:active {
    color: hsl(var(--hsl-button-yellow-soft-press-foreground));
}
#login .active\\:text-button-yellow-solid-press-foreground:active {
    color: hsl(var(--hsl-button-yellow-solid-press-foreground));
}
#login .active\\:text-button-yellow-surface-press-foreground:active {
    color: hsl(var(--hsl-button-yellow-surface-press-foreground));
}
#login .active\\:ring-2:active {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .active\\:ring-active:active {
    --tw-ring-color: hsl(var(--hsl-active));
}
#login :is(.group\\/input:hover .active\\:group-hover\\/input\\:ring-2:active) {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login :is(.group\\/input:hover .active\\:group-hover\\/input\\:ring-active:active) {
    --tw-ring-color: hsl(var(--hsl-active));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-blue-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-blue-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-cyan-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-cyan-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-green-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-green-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-inverse-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-inverse-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-neutral-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-neutral-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-primary-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-primary-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-purple-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-purple-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-red-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-red-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:border-button-yellow-surface-border:active[data-state="on"] {
    border-color: hsl(var(--hsl-button-yellow-surface-default-border));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-blue-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-blue-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-cyan-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-cyan-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-green-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-green-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-inverse-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-inverse-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-neutral-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-neutral-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-primary-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-primary-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-purple-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-purple-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-red-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-red-surface-default-background));
}
#login .data-\\[state\\=on\\]\\:active\\:bg-button-yellow-surface:active[data-state="on"] {
    background-color: hsl(var(--hsl-button-yellow-surface-default-background));
}
#login .disabled\\:pointer-events-none:disabled {
    pointer-events: none;
}
#login .disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
}
#login .disabled\\:border-0:disabled {
    border-width: 0px;
}
#login .disabled\\:border-button-blue-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-blue-outline-disabled-border));
}
#login .disabled\\:border-button-blue-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-blue-surface-disabled-border));
}
#login .disabled\\:border-button-cyan-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-cyan-outline-disabled-border));
}
#login .disabled\\:border-button-cyan-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-cyan-surface-disabled-border));
}
#login .disabled\\:border-button-green-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-green-outline-disabled-border));
}
#login .disabled\\:border-button-green-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-green-surface-disabled-border));
}
#login .disabled\\:border-button-inverse-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-inverse-outline-disabled-border));
}
#login .disabled\\:border-button-inverse-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-inverse-surface-disabled-border));
}
#login .disabled\\:border-button-neutral-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-neutral-outline-disabled-border));
}
#login .disabled\\:border-button-neutral-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-neutral-surface-disabled-border));
}
#login .disabled\\:border-button-primary-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-primary-outline-disabled-border));
}
#login .disabled\\:border-button-primary-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-primary-surface-disabled-border));
}
#login .disabled\\:border-button-purple-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-purple-outline-disabled-border));
}
#login .disabled\\:border-button-purple-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-purple-surface-disabled-border));
}
#login .disabled\\:border-button-red-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-red-outline-disabled-border));
}
#login .disabled\\:border-button-red-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-red-surface-disabled-border));
}
#login .disabled\\:border-button-yellow-outline-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-yellow-outline-disabled-border));
}
#login .disabled\\:border-button-yellow-surface-disabled-border:disabled {
    border-color: hsl(var(--hsl-button-yellow-surface-disabled-border));
}
#login .disabled\\:bg-button-blue-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-blue-ghost-disabled-background));
}
#login .disabled\\:bg-button-blue-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-blue-soft-disabled-background));
}
#login .disabled\\:bg-button-blue-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-blue-solid-disabled-background));
}
#login .disabled\\:bg-button-blue-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-blue-surface-disabled-background));
}
#login .disabled\\:bg-button-cyan-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-cyan-ghost-disabled-background));
}
#login .disabled\\:bg-button-cyan-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-cyan-soft-disabled-background));
}
#login .disabled\\:bg-button-cyan-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-cyan-solid-disabled-background));
}
#login .disabled\\:bg-button-cyan-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-cyan-surface-disabled-background));
}
#login .disabled\\:bg-button-green-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-green-ghost-disabled-background));
}
#login .disabled\\:bg-button-green-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-green-soft-disabled-background));
}
#login .disabled\\:bg-button-green-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-green-solid-disabled-background));
}
#login .disabled\\:bg-button-green-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-green-surface-disabled-background));
}
#login .disabled\\:bg-button-inverse-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-inverse-ghost-disabled-background));
}
#login .disabled\\:bg-button-inverse-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-inverse-soft-disabled-background));
}
#login .disabled\\:bg-button-inverse-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-inverse-solid-disabled-background));
}
#login .disabled\\:bg-button-inverse-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-inverse-surface-disabled-background));
}
#login .disabled\\:bg-button-neutral-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-neutral-ghost-disabled-background));
}
#login .disabled\\:bg-button-neutral-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-neutral-soft-disabled-background));
}
#login .disabled\\:bg-button-neutral-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-neutral-solid-disabled-background));
}
#login .disabled\\:bg-button-neutral-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-neutral-surface-disabled-background));
}
#login .disabled\\:bg-button-primary-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-primary-ghost-disabled-background));
}
#login .disabled\\:bg-button-primary-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-primary-soft-disabled-background));
}
#login .disabled\\:bg-button-primary-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-primary-solid-disabled-background));
}
#login .disabled\\:bg-button-purple-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-purple-ghost-disabled-background));
}
#login .disabled\\:bg-button-purple-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-purple-soft-disabled-background));
}
#login .disabled\\:bg-button-purple-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-purple-solid-disabled-background));
}
#login .disabled\\:bg-button-purple-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-purple-surface-disabled-background));
}
#login .disabled\\:bg-button-red-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-red-ghost-disabled-background));
}
#login .disabled\\:bg-button-red-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-red-soft-disabled-background));
}
#login .disabled\\:bg-button-red-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-red-solid-disabled-background));
}
#login .disabled\\:bg-button-red-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-red-surface-disabled-background));
}
#login .disabled\\:bg-button-yellow-ghost-disabled:disabled {
    background-color: hsl(var(--hsl-button-yellow-ghost-disabled-background));
}
#login .disabled\\:bg-button-yellow-soft-disabled:disabled {
    background-color: hsl(var(--hsl-button-yellow-soft-disabled-background));
}
#login .disabled\\:bg-button-yellow-solid-disabled:disabled {
    background-color: hsl(var(--hsl-button-yellow-solid-disabled-background));
}
#login .disabled\\:bg-button-yellow-surface-disabled:disabled {
    background-color: hsl(var(--hsl-button-yellow-surface-disabled-background));
}
#login .disabled\\:bg-transparent:disabled {
    background-color: transparent;
}
#login .disabled\\:text-button-blue-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-blue-ghost-disabled-foreground));
}
#login .disabled\\:text-button-blue-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-blue-outline-disabled-foreground));
}
#login .disabled\\:text-button-blue-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-blue-soft-disabled-foreground));
}
#login .disabled\\:text-button-blue-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-blue-solid-disabled-foreground));
}
#login .disabled\\:text-button-blue-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-blue-surface-disabled-foreground));
}
#login .disabled\\:text-button-cyan-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-cyan-ghost-disabled-foreground));
}
#login .disabled\\:text-button-cyan-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-cyan-outline-disabled-foreground));
}
#login .disabled\\:text-button-cyan-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-cyan-soft-disabled-foreground));
}
#login .disabled\\:text-button-cyan-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-cyan-solid-disabled-foreground));
}
#login .disabled\\:text-button-cyan-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-cyan-surface-disabled-foreground));
}
#login .disabled\\:text-button-green-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-green-ghost-disabled-foreground));
}
#login .disabled\\:text-button-green-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-green-outline-disabled-foreground));
}
#login .disabled\\:text-button-green-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-green-soft-disabled-foreground));
}
#login .disabled\\:text-button-green-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-green-solid-disabled-foreground));
}
#login .disabled\\:text-button-green-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-green-surface-disabled-foreground));
}
#login .disabled\\:text-button-inverse-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-inverse-ghost-disabled-foreground));
}
#login .disabled\\:text-button-inverse-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-inverse-outline-disabled-foreground));
}
#login .disabled\\:text-button-inverse-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-inverse-soft-disabled-foreground));
}
#login .disabled\\:text-button-inverse-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-inverse-solid-disabled-foreground));
}
#login .disabled\\:text-button-inverse-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-inverse-surface-disabled-foreground));
}
#login .disabled\\:text-button-neutral-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-neutral-ghost-disabled-foreground));
}
#login .disabled\\:text-button-neutral-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-neutral-outline-disabled-foreground));
}
#login .disabled\\:text-button-neutral-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-neutral-soft-disabled-foreground));
}
#login .disabled\\:text-button-neutral-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-neutral-solid-disabled-foreground));
}
#login .disabled\\:text-button-neutral-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-neutral-surface-disabled-foreground));
}
#login .disabled\\:text-button-primary-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-primary-ghost-disabled-foreground));
}
#login .disabled\\:text-button-primary-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-primary-outline-disabled-foreground));
}
#login .disabled\\:text-button-primary-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-primary-soft-disabled-foreground));
}
#login .disabled\\:text-button-primary-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-primary-solid-disabled-foreground));
}
#login .disabled\\:text-button-primary-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-primary-surface-disabled-foreground));
}
#login .disabled\\:text-button-purple-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-purple-ghost-disabled-foreground));
}
#login .disabled\\:text-button-purple-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-purple-outline-disabled-foreground));
}
#login .disabled\\:text-button-purple-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-purple-soft-disabled-foreground));
}
#login .disabled\\:text-button-purple-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-purple-solid-disabled-foreground));
}
#login .disabled\\:text-button-purple-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-purple-surface-disabled-foreground));
}
#login .disabled\\:text-button-red-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-red-ghost-disabled-foreground));
}
#login .disabled\\:text-button-red-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-red-outline-disabled-foreground));
}
#login .disabled\\:text-button-red-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-red-soft-disabled-foreground));
}
#login .disabled\\:text-button-red-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-red-solid-disabled-foreground));
}
#login .disabled\\:text-button-red-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-red-surface-disabled-foreground));
}
#login .disabled\\:text-button-yellow-ghost-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-yellow-ghost-disabled-foreground));
}
#login .disabled\\:text-button-yellow-outline-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-yellow-outline-disabled-foreground));
}
#login .disabled\\:text-button-yellow-soft-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-yellow-soft-disabled-foreground));
}
#login .disabled\\:text-button-yellow-solid-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-yellow-solid-disabled-foreground));
}
#login .disabled\\:text-button-yellow-surface-disabled-foreground:disabled {
    color: hsl(var(--hsl-button-yellow-surface-disabled-foreground));
}
#login .disabled\\:text-foreground-tertiary:disabled {
    color: hsl(var(--hsl-foreground-tertiary));
}
#login .disabled\\:opacity-40:disabled {
    opacity: 0.4;
}
#login .disabled\\:opacity-60:disabled {
    opacity: 0.6;
}
#login .disabled\\:ring-0:disabled {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login :is(.group\\/input:hover .disabled\\:group-hover\\/input\\:ring-0:disabled) {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#login .data-\\[state\\=off\\]\\:disabled\\:border-selectable-card-inactive-border-disabled:disabled[data-state="off"] {
    border-color: hsl(var(--hsl-selectable-card-inactive-disabled-border));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-blue-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-blue-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-cyan-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-cyan-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-green-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-green-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-inverse-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-inverse-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-neutral-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-neutral-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-primary-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-primary-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-purple-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-purple-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-red-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-red-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-button-yellow-skeleton:disabled[data-loading="true"] {
    background-color: hsl(var(--hsl-button-yellow-skeleton));
}
#login .data-\\[loading\\=true\\]\\:disabled\\:bg-transparent:disabled[data-loading="true"] {
    background-color: transparent;
}
@container lozenge (min-width: 56px) {
    #login .\\@\\[56px\\]\\/lozenge\\:visible {
        visibility: visible;
    }
}
@container lozenge (min-width: 100px) {
    #login .\\@\\[100px\\]\\/lozenge\\:visible {
        visibility: visible;
    }
}
@container lozenge (min-width: 144px) {
    #login .\\@\\[144px\\]\\/lozenge\\:visible {
        visibility: visible;
    }
}
@container lozenge (min-width: 188px) {
    #login .\\@\\[188px\\]\\/lozenge\\:visible {
        visibility: visible;
    }
}
@container lozenge (min-width: 232px) {
    #login .\\@\\[232px\\]\\/lozenge\\:visible {
        visibility: visible;
    }
}
#login .dark\\:bg-neutral-85:is(.dark *) {
    background-color: hsl(var(--hsl-neutral-85));
}
#login .dark\\:bg-neutral-95:is(.dark *) {
    background-color: hsl(var(--hsl-neutral-95));
}
#login .dark\\:bg-overlay\\/55:is(.dark *) {
    background-color: hsl(var(--hsl-overlay) / 0.55);
}
#login .dark\\:text-purple-50:is(.dark *) {
    color: hsl(var(--hsl-purple-50));
}
@media (min-width: 640px) {
    #login .sm\\:block {
        display: block;
    }
    #login .sm\\:hidden {
        display: none;
    }
    #login .sm\\:w-96 {
        width: 24rem;
    }
    #login .sm\\:max-w-sm {
        max-width: 24rem;
    }
    #login .sm\\:whitespace-nowrap {
        white-space: nowrap;
    }
    #login .sm\\:text-2xl {
        font-size: 1.5rem;
        line-height: 2.25rem;
    }
}
@media (min-width: 768px) {
    #login .md\\:sticky {
        position: sticky;
    }
    #login .md\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px;
    }
    #login .md\\:grid-flow-col {
        grid-auto-flow: column;
    }
}
#login :is(.peer:focus ~ .rtl\\:peer-focus\\:left-auto:where([dir="rtl"], [dir="rtl"] *)) {
    left: auto;
}
#login :is(.peer:focus ~ .rtl\\:peer-focus\\:translate-x-1\\/4:where([dir="rtl"], [dir="rtl"] *)) {
    --tw-translate-x: 25%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#login .\\[\\&\\:not\\(\\[hidden\\]\\)\\]\\:grid:not([hidden]) {
    display: grid;
}
#login .\\[\\&\\:nth-child\\(even\\)\\]\\:bg-card-secondary:nth-child(even) {
    background-color: hsl(var(--hsl-card-secondary));
}
#login .\\[\\&\\:nth-child\\(odd\\)\\]\\:bg-card-secondary:nth-child(odd) {
    background-color: hsl(var(--hsl-card-secondary));
}
#login :is(.\\[\\&\\>\\*\\:last-child\\]\\:border-r-0>*:last-child) {
    border-right-width: 0px;
}
#login :is(.\\[\\&\\>\\*\\]\\:pointer-events-none>*) {
    pointer-events: none;
}
#login :is(.\\[\\&\\>\\*\\]\\:grow>*) {
    flex-grow: 1;
}
#login :is(.\\[\\&\\>\\*\\]\\:border-r>*) {
    border-right-width: 1px;
}
#login :is(.\\[\\&\\>\\*\\]\\:border-r-border>*) {
    border-right-color: hsl(var(--hsl-border));
}
#login :is(.\\[\\&\\>\\*\\]\\:border-r-transparent>*) {
    border-right-color: transparent;
}
#login :is(.active\\:\\[\\&\\>\\:not\\(\\:disabled\\)\\]\\:border-active-foreground>:not(:disabled):active) {
    border-color: hsl(var(--hsl-active-foreground));
}
#login :is(.\\[\\&\\>button\\]\\:hover\\:bg-button-ghost-hover:hover>button) {
    background-color: hsl(var(--hsl-button-ghost-hover));
}
#login :is(.\\[\\&\\>button\\]\\:hover\\:bg-chip-blue-hover:hover>button) {
    background-color: hsl(var(--hsl-chip-blue-hover));
}
#login :is(.\\[\\&\\>button\\]\\:hover\\:bg-error-hover:hover>button) {
    background-color: hsl(var(--hsl-error-hover));
}
#login :is(.\\[\\&\\>button\\]\\:hover\\:bg-info-hover:hover>button) {
    background-color: hsl(var(--hsl-info-hover));
}
#login :is(.\\[\\&\\>button\\]\\:hover\\:bg-success-hover:hover>button) {
    background-color: hsl(var(--hsl-success-hover));
}
#login :is(.\\[\\&\\>button\\]\\:hover\\:bg-warning-hover:hover>button) {
    background-color: hsl(var(--hsl-warning-hover));
}
#login :is(.\\[\\&\\>li\\:first-child\\]\\:rounded-t>li:first-child) {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
#login :is(.\\[\\&\\>li\\:last-child\\]\\:rounded-b>li:last-child) {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
#login :is(.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-3 [cmdk-group-heading]) {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
#login :is(.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]) {
    font-size: 0.75rem;
    line-height: 1.1rem;
}
#login :is(.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]) {
    font-weight: 500;
}
#login :is(.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-foreground-secondary [cmdk-group-heading]) {
    color: hsl(var(--hsl-foreground-secondary));
}
#login :is(.group.toaster .group-\\[\\.toaster\\]\\:\\[\\&_svg\\]\\:m-0 svg) {
    margin: 0px;
}
#login :is(.\\[\\&_th\\]\\:\\!rounded-b-none th) {
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}
#login :is(.\\[\\&_th\\]\\:\\!border-solid th) {
    border-style: solid !important;
}
#login :is(.\\[\\&_tr\\]\\:\\!bg-card tr) {
    background-color: hsl(var(--hsl-card)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,SAAmB;IAAnB;AAAmB;AAAnB;IAAA,QAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;OAAnB,sBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,0DAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB,qCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB,qCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kGAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wJAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,mCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;QAAA,kCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,gBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA,sBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,gBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA,+BACA;IADA;AACA;AADA;IAAA,gCACA;IADA;AACA;AADA;IAAA,+BACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,mCACA;IADA;AACA;AADA;IAAA,gCACA;IADA;AACA;AADA;IAAA,iCACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,sBACA;IADA;AACA;AADA;IAAA,eACA;IADA,eACA;IADA;AACA;AADA;IAAA,eACA;IADA,eACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA,uBACA;IADA;AACA;AADA;IAAA,iBACA;IADA,iBACA;IADA;AACA;AADA;IAAA,oBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,yBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,yBACA;IADA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA;QAAA;IACA;AAAA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,qBACA;IADA,yBACA;IADA,2BACA;IADA,yBACA;IADA,0BACA;IADA,+BACA;IADA;AACA;AADA;IAAA,oBACA;IADA,yBACA;IADA,0BACA;IADA,wBACA;IADA,yBACA;IADA,8BACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,0BACA;IADA;AACA;AADA;IAAA,kBACA;IADA,UACA;IADA,WACA;IADA,UACA;IADA,YACA;IADA,gBACA;IADA,sBACA;IADA,mBACA;IADA;AACA;AADA;IAAA,gBACA;IADA,WACA;IADA,YACA;IADA,UACA;IADA,SACA;IADA,iBACA;IADA,UACA;IADA;AACA;AADA;IAAA,gBACA;IADA,WACA;IADA,YACA;IADA,UACA;IADA,SACA;IADA,i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yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,8BACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,qBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,8BACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA,2GACA;IADA,yGACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;AAAA;AADA;IAAA;QAAA;IACA;AAAA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA;IACA;IADA;QAAA,iBACA;QADA;IACA;AAAA;AADA;IAAA;QAAA;IACA;IADA;QAAA,gBACA;QADA;IACA;IADA;QAAA;IACA;AAAA;AADA;IAAA;AACA;AADA;IAAA,qBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,+BACA;IADA;AACA;AADA;IAAA,mCACA;IADA;AACA;AADA;IAAA,qBACA;IADA;AACA;AADA;IAAA,kBACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA;AADA;IAAA,0CACA;IADA;AACA;AADA;IAAA;AACA;AADA;IAAA;AACA","sourcesContent":["@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
